if (!customElements.get("atlas-skio-dynamic-box")) {
    void (() => {
        const invalidateCartCache = (...args) =>
            window.atlasGwpShared?.invalidateCartJsCache?.(...args);
        const refreshRebuyCart = (...args) =>
            window.atlasGwpShared?.refreshRebuyCart?.(...args);

        const CHEVRON_DOWN_SVG =
            '<svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 0.5L5.5 5.5L10.5 0.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        const CHECKMARK_SVG =
            '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9"><path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/></svg>';
        const PLUS_SVG =
            '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg>';
        const MINUS_SVG =
            '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"/></svg>';
        const CLOSE_X_SVG =
            '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M4.375 4.375L13.125 13.125" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.125 4.375L4.375 13.125" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        const STAR_SVG =
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="currentColor"><path d="M10 1.5l2.59 5.25 5.8.84-4.2 4.09.99 5.78L10 14.6l-5.18 2.86.99-5.78-4.2-4.09 5.8-.84L10 1.5z"/></svg>';
        const SKIO_DYNAMIC_BOX_ENDPOINT =
            "https://api.skio.com/storefront-http/get-dynamic-box";
        const ONE_TIME = "onetime";
        const OTHER_GROUP_TITLE = "Other Products";
        const RANGE_GROUP_HANDLES = [
            "pre-probiotic-blends",
            "hormone-gummies",
            "enhanced-electrolytes",
            "am-blends",
            "pm-blends",
            "functional-protein",
            "accessories"
        ];
        const WELCOME_KIT_MAX_ITEMS = 3;
        const DEFAULT_OTP_BYOB_DISCOUNT_PERCENTS = {
            2: 5,
            3: 10,
            4: 16
        };

        function otpByobPercentForSize(size, percents) {
            const source =
                percents && typeof percents === "object"
                    ? percents
                    : DEFAULT_OTP_BYOB_DISCOUNT_PERCENTS;
            const count = Number(size) || 0;
            const keys = Object.keys(source)
                .map((key) => Number.parseInt(key, 10))
                .filter((key) => Number.isFinite(key) && key > 0)
                .sort((a, b) => a - b);
            let percent = 0;
            for (const key of keys) {
                if (count >= key) {
                    percent = Number(source[String(key)] ?? source[key]) || 0;
                }
            }
            return percent;
        }

        function extractNumericId(rawId) {
            if (rawId == null) return null;
            const match = String(rawId).match(/(\d+)\s*$/);
            return match ? parseInt(match[1], 10) : null;
        }

        function sellingPlanSortValue(plan) {
            const position = Number(plan?.position);
            if (Number.isFinite(position)) return position;
            const count = Number(plan?.intervalCount) || 0;
            const interval = String(plan?.interval || "DAY").toUpperCase();
            if (interval === "WEEK") return count * 7;
            if (interval === "MONTH") return count * 30;
            if (interval === "YEAR") return count * 365;
            return count;
        }

        function formatMoney(amount, currencyCode) {
            const locale = window.Shopify?.locale || undefined;
            try {
                return new Intl.NumberFormat(locale, {
                    style: "currency",
                    currency: currencyCode || "USD"
                }).format(roundMoney(amount));
            } catch {
                return `${roundMoney(amount).toFixed(2)} ${currencyCode || ""}`.trim();
            }
        }

        function roundMoney(amount) {
            return Math.round((Number(amount) || 0) * 100) / 100;
        }

        function applyPercentOff(amount, percent) {
            const cents = Math.round((Number(amount) || 0) * 100);
            const safePercent = Math.min(
                100,
                Math.max(0, Number(percent) || 0)
            );
            const discountCents = Math.floor((cents * safePercent) / 100);
            return (cents - discountCents) / 100;
        }

        function formatMoneyNoCodeRounded(amount, currencyCode) {
            const value = roundMoney(amount);
            const hasCents = Math.round(value * 100) % 100 !== 0;
            const locale = window.Shopify?.locale || undefined;
            try {
                return new Intl.NumberFormat(locale, {
                    style: "currency",
                    currency: currencyCode || "USD",
                    minimumFractionDigits: hasCents ? 2 : 0,
                    maximumFractionDigits: hasCents ? 2 : 0
                })
                    .format(value)
                    .replace(/^[A-Z]{2,3}(?=\D*\d)/, "");
            } catch {
                return `${value}`;
            }
        }

        function formatMoneyNoCode(amount, currencyCode) {
            return formatMoney(amount, currencyCode).replace(
                /^[A-Z]{2,3}(?=\D*\d)/,
                ""
            );
        }

        class AtlasSkioDynamicBox extends HTMLElement {
            constructor() {
                super();
                this.box = null;
                this.variantsByPlatformId = new Map();
                this.slots = [];
                this.groups = [];
                this.openGroups = new Set();
                this.purchaseType = ONE_TIME;
                this.summaryOpen = true;
                this.bundleSummaryOpen = true;
                this.welcomeKitCategories = [];
                this.welcomeKitSelections = new Map();
                this.isSubmitting = false;
                this._tiers = null;
                this._oneTimeDiscountBySize = null;
                this._variantCounts = new Map();
                this._filledCount = 0;
                this._basePrice = 0;
                this._boxRequestController = null;
                this._quickViewRequestController = null;
                this._quickViewHtmlCache = new Map();
                this._stickyFrame = null;
                this.handleRootClick = this.handleRootClick.bind(this);
                this.handleRootChange = this.handleRootChange.bind(this);
                this.handleGroupTransitionEnd =
                    this.handleGroupTransitionEnd.bind(this);
                this._pendingGroupScrollToggle = null;
                this._groupScrollSettleTimer = null;
                this._groupScrollSettleToken = 0;
            }

            connectedCallback() {
                // This component lives inside the theme's <product-form>, which
                // scans its whole subtree for a submit/product-buy button and wires
                // up its own click handling. Stop clicks on our own controls
                // (buttons, radios, the plan <select>, etc.) from bubbling out to
                // that ancestor — otherwise it can react to them and navigate/submit.
                this.removeEventListener("click", this.handleRootClick);
                this.removeEventListener("change", this.handleRootChange);
                this.removeEventListener(
                    "transitionend",
                    this.handleGroupTransitionEnd
                );
                this.addEventListener("click", this.handleRootClick);
                this.addEventListener("change", this.handleRootChange);
                // .skio-dynamic-box__group-body's `grid-template-rows 0.3s`
                // accordion transition — see scheduleGroupScrollSettle().
                this.addEventListener(
                    "transitionend",
                    this.handleGroupTransitionEnd
                );
                this.handleOtpByobDiscountReady = () => {
                    if (!this.box) return;
                    this.updatePlanPricingUI();
                    this.render();
                };
                document.addEventListener(
                    "atlas:otp-byob-discount-ready",
                    this.handleOtpByobDiscountReady
                );

                this.blockId = this.getAttribute("data-block-id") || "";
                this.apiKey = this.getAttribute("data-api-key") || "";
                this.productPlatformId =
                    this.getAttribute("data-product-platform-id") || "";
                this.buttonLabel =
                    this.getAttribute("data-button-label") || "Add to Cart";
                this.quickViewId = this.getAttribute("data-quick-view-id");
                this.collectionsMapId = this.getAttribute(
                    "data-collections-map-id"
                );
                this.welcomeKitId = this.getAttribute("data-welcome-kit-id");
                this.welcomeKitPlaceholderVariantId = extractNumericId(
                    this.getAttribute("data-welcome-kit-placeholder-variant-id")
                );
                this.welcomeKitPlaceholderCompareAt = parseFloat(
                    this.getAttribute(
                        "data-welcome-kit-placeholder-compare-at"
                    ) || "0"
                );
                if (!Number.isFinite(this.welcomeKitPlaceholderCompareAt)) {
                    this.welcomeKitPlaceholderCompareAt = 0;
                }
                this.welcomeKitHeading =
                    this.getAttribute("data-welcome-kit-heading") ||
                    "You've unlocked a FREE Welcome Kit 🥳";
                this.welcomeKitSubheading =
                    this.getAttribute("data-welcome-kit-subheading") || "";
                this.welcomeKitTeaserImage =
                    this.getAttribute("data-welcome-kit-teaser-image") || "";
                this.welcomeKitTeaserHeading =
                    this.getAttribute("data-welcome-kit-teaser-heading") || "";
                this.welcomeKitTeaserHeadingMobile =
                    this.getAttribute(
                        "data-welcome-kit-teaser-heading-mobile"
                    ) || "";
                this.welcomeKitTeaserSubheading =
                    this.getAttribute("data-welcome-kit-teaser-subheading") ||
                    "";
                this.frequencyBannerSubscribe =
                    this.getAttribute("data-frequency-banner-subscribe") ||
                    "Unlock up to {percent}% off and free Welcome Kit (worth up to {worth})";
                this.frequencyBannerMobile =
                    this.getAttribute("data-frequency-banner-mobile") ||
                    "UNLOCK FREE GIFTS AND ADDITIONAL SAVINGS";
                this.perksId = this.getAttribute("data-perks-id");
                this.purchaseInputName = `skio-purchase-type-${
                    this.blockId || this.productPlatformId
                }`.replace(/[^a-zA-Z0-9_-]/g, "-");
                const shippingCostAttr = this.getAttribute(
                    "data-one-time-shipping-cost"
                );
                this.oneTimeShippingCostShop = shippingCostAttr
                    ? parseFloat(shippingCostAttr)
                    : null;
                this.oneTimeShippingCost = this.oneTimeShippingCostShop;
                this.presentmentCurrencyCode =
                    this.getAttribute("data-currency-code") ||
                    window.Shopify?.currency?.active ||
                    "";
                this.shopCurrencyCode =
                    this.getAttribute("data-shop-currency-code") ||
                    window.Shopify?.currency?.active ||
                    "";
                this._shopifyPriceByVariantId = new Map();

                if (!this.productPlatformId) {
                    this.renderError(
                        "Missing Dynamic Box product ID. Set it in the block settings."
                    );
                    return;
                }

                if (this.box) {
                    if (!this.querySelector("[data-skio-submit]")) {
                        this.render();
                    } else {
                        this.setupStickyObserver();
                    }
                    return;
                }

                this.loadBox();
            }

            handleRootClick(event) {
                const control = event.target.closest(
                    "button, a, label, select, input"
                );
                if (control) event.stopPropagation();

                const submitButton = event.target.closest("[data-skio-submit]");
                if (submitButton) {
                    this.handleSubmit();
                    return;
                }

                const boxToggle = event.target.closest("[data-skio-toggle]");
                if (boxToggle) {
                    this.summaryOpen = !this.summaryOpen;
                    this.renderSlots();
                    return;
                }

                const removeButton = event.target.closest("[data-skio-remove]");
                if (removeButton) {
                    const slot = removeButton.closest("[data-slot-index]");
                    this.clearSlot(
                        Number.parseInt(slot?.dataset.slotIndex, 10)
                    );
                    return;
                }

                const groupToggle = event.target.closest(
                    "[data-skio-group-toggle]"
                );
                if (groupToggle) {
                    const groupEl = groupToggle.closest("[data-group-title]");
                    const title = groupEl?.dataset.groupTitle;
                    if (!title) return;

                    const isOpen = this.openGroups.has(title);
                    if (isOpen) {
                        this.openGroups.delete(title);
                        groupEl.classList.remove("is-open");
                        groupToggle
                            .querySelector(".skio-dynamic-box__chevron")
                            ?.classList.remove("is-open");
                    } else {
                        this.querySelectorAll(
                            "[data-skio-groups] [data-group-title].is-open"
                        ).forEach((openEl) => {
                            openEl.classList.remove("is-open");
                            openEl
                                .querySelector(".skio-dynamic-box__chevron")
                                ?.classList.remove("is-open");
                        });
                        this.openGroups = new Set([title]);
                        groupEl.classList.add("is-open");
                        groupToggle
                            .querySelector(".skio-dynamic-box__chevron")
                            ?.classList.add("is-open");
                        this.scheduleGroupScrollSettle(groupToggle);
                    }
                    return;
                }

                const quickViewButton = event.target.closest(
                    "[data-skio-quick-view]"
                );
                if (quickViewButton) {
                    event.preventDefault();
                    this.showQuickView(quickViewButton);
                    return;
                }

                const groupItem = event.target.closest(
                    "[data-skio-group-item]"
                );
                if (
                    groupItem &&
                    !event.target.closest(
                        "[data-skio-increment], [data-skio-decrement], .skio-dynamic-box__stepper"
                    )
                ) {
                    const quickViewTrigger = groupItem.querySelector(
                        "[data-skio-quick-view]"
                    );
                    if (quickViewTrigger) {
                        event.preventDefault();
                        this.showQuickView(quickViewTrigger);
                        return;
                    }
                }

                const incrementButton = event.target.closest(
                    "[data-skio-increment]"
                );
                if (incrementButton) {
                    this.addVariant(incrementButton.dataset.platformId);
                    return;
                }

                const decrementButton = event.target.closest(
                    "[data-skio-decrement]"
                );
                if (decrementButton) {
                    this.removeVariant(decrementButton.dataset.platformId);
                    return;
                }

                const welcomeKitButton = event.target.closest(
                    "[data-skio-welcome-kit-pick]"
                );
                if (welcomeKitButton) {
                    this.toggleWelcomeKitSelection(
                        welcomeKitButton.dataset.category,
                        welcomeKitButton.dataset.variantId
                    );
                    return;
                }

                const bundleToggle = event.target.closest(
                    "[data-skio-bundle-toggle]"
                );
                if (bundleToggle) {
                    this.bundleSummaryOpen = this.bundleSummaryOpen === false;
                    this.renderSummary();
                }
            }

            handleRootChange(event) {
                const purchaseTypeInput = event.target.closest(
                    "[data-skio-purchase-type]"
                );
                if (purchaseTypeInput) {
                    const clickedValue = purchaseTypeInput.value;
                    const nextPurchaseType =
                        clickedValue === ONE_TIME
                            ? ONE_TIME
                            : this.purchaseType === ONE_TIME
                              ? this.planEntries[0][0]
                              : this.purchaseType;

                    const applyPurchaseTypeChange = () => {
                        this.purchaseType = nextPurchaseType;
                        this.renderPlans();
                        this.renderTiers();
                        this.renderWelcomeKit();
                        this.renderSummary();
                        this.persistSelection();
                    };

                    // Only Subscribe & Save <-> One-time Purchase carries
                    // extra content (frequency select, welcome kit, perks)
                    // that needs to roll up first — switching the delivery
                    // frequency plan while staying subscribed doesn't change
                    // which content is shown, so it can apply immediately.
                    const switchingPurchaseFamily =
                        (this.purchaseType === ONE_TIME) !==
                        (nextPurchaseType === ONE_TIME);

                    if (switchingPurchaseFamily) {
                        this.collapseFrequencyExtras(
                            applyPurchaseTypeChange,
                            purchaseTypeInput,
                            `[data-skio-purchase-type][value="${clickedValue}"]`
                        );
                    } else {
                        applyPurchaseTypeChange();
                    }
                    return;
                }

                const planSelect = event.target.closest(
                    "[data-skio-plan-select]"
                );
                if (!planSelect) return;

                this.purchaseType = planSelect.value;
                this.renderPlans();
                this.renderTiers();
                this.renderWelcomeKit();
                this.renderSummary();
                this.persistSelection();
            }

            async loadBox() {
                this.renderLoading();
                this._boxRequestController?.abort();
                const controller = new AbortController();
                this._boxRequestController = controller;

                try {
                    const response = await fetch(SKIO_DYNAMIC_BOX_ENDPOINT, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            ...(this.apiKey
                                ? { Authorization: `API ${this.apiKey}` }
                                : {})
                        },
                        body: JSON.stringify({
                            productPlatformId: this.productPlatformId
                        }),
                        signal: controller.signal
                    });

                    if (!response.ok) {
                        throw new Error(
                            `Skio API responded with ${response.status}`
                        );
                    }

                    const payload = await response.json();
                    if (payload?.ok === false) {
                        throw new Error(
                            payload?.extensions?.detail ||
                                "Skio API returned an error"
                        );
                    }
                    this.box = payload?.DynamicBox || payload?.data || payload;
                    await this.localizeBoxPrices();
                    this.setupBox();
                    this.buildGroups();
                    if (!this.isConnected || controller.signal.aborted) return;
                    this.render();
                    await this.loadWelcomeKitPlaceholderCompareAt();
                    if (
                        this.isConnected &&
                        !controller.signal.aborted &&
                        this.welcomeKitPlaceholderCompareAt > 0
                    ) {
                        this.renderSummary();
                    }
                } catch (error) {
                    if (error.name === "AbortError") return;
                    console.error(
                        "AtlasSkioDynamicBox: failed to load box",
                        error
                    );
                    this.renderError(
                        "This box couldn't be loaded right now. Please try again shortly."
                    );
                } finally {
                    if (this._boxRequestController === controller) {
                        this._boxRequestController = null;
                    }
                }
            }

            getPresentmentCurrencyCode() {
                return (
                    window.Shopify?.currency?.active ||
                    this.presentmentCurrencyCode ||
                    this.box?.currencyCode ||
                    "USD"
                );
            }

            getPresentmentCurrencyRate() {
                const rate = Number(window.Shopify?.currency?.rate);
                return Number.isFinite(rate) && rate > 0 ? rate : 1;
            }

            getStorefrontRoot() {
                const root = window.Shopify?.routes?.root || "/";
                return root.endsWith("/") ? root : `${root}/`;
            }

            convertShopAmountToPresentment(amount) {
                const value = Number(amount) || 0;
                const presentment = this.getPresentmentCurrencyCode();
                const shop =
                    this.shopCurrencyCode ||
                    this.box?.currencyCode ||
                    presentment;
                if (!value || !shop || shop === presentment) {
                    return roundMoney(value);
                }
                return roundMoney(value * this.getPresentmentCurrencyRate());
            }

            async fetchShopifyProductPrices(handle) {
                if (!handle) return;
                try {
                    const response = await fetch(
                        `${this.getStorefrontRoot()}products/${encodeURIComponent(handle)}.js`,
                        { credentials: "same-origin" }
                    );
                    if (!response.ok) return;
                    const product = await response.json();
                    (product.variants || []).forEach((variant) => {
                        const variantId = String(variant.id);
                        this._shopifyPriceByVariantId.set(variantId, {
                            price: roundMoney(
                                (Number(variant.price) || 0) / 100
                            ),
                            compareAtPrice:
                                variant.compare_at_price != null &&
                                variant.compare_at_price !== ""
                                    ? roundMoney(
                                          (Number(variant.compare_at_price) ||
                                              0) / 100
                                      )
                                    : null
                        });
                    });
                } catch (error) {
                    console.warn(
                        "AtlasSkioDynamicBox: failed to load localized product prices",
                        handle,
                        error
                    );
                }
            }

            applyLocalizedPriceToVariant(variant) {
                if (!variant) return;
                const variantId = String(
                    extractNumericId(variant.platformId) || ""
                );
                const localized = variantId
                    ? this._shopifyPriceByVariantId.get(variantId)
                    : null;

                if (localized) {
                    variant.price = localized.price;
                    if (localized.compareAtPrice != null) {
                        variant.compareAtPrice = localized.compareAtPrice;
                    }
                    return;
                }

                const presentment = this.getPresentmentCurrencyCode();
                const sourceCurrency =
                    this.box?.currencyCode || this.shopCurrencyCode;
                if (
                    sourceCurrency &&
                    presentment &&
                    sourceCurrency !== presentment
                ) {
                    variant.price = this.convertShopAmountToPresentment(
                        variant.price
                    );
                    if (variant.compareAtPrice != null) {
                        variant.compareAtPrice =
                            this.convertShopAmountToPresentment(
                                variant.compareAtPrice
                            );
                    }
                }
            }

            async localizeBoxPrices() {
                if (!this.box) return;

                this._shopifyPriceByVariantId = new Map();
                const handles = [
                    ...new Set(
                        (this.box.selectableProductVariants || [])
                            .map((product) => product.productHandle)
                            .filter(Boolean)
                    )
                ];

                await Promise.all(
                    handles.map((handle) =>
                        this.fetchShopifyProductPrices(handle)
                    )
                );

                (this.box.selectableProductVariants || []).forEach(
                    (product) => {
                        (product.productVariants || []).forEach((variant) => {
                            this.applyLocalizedPriceToVariant(variant);
                        });
                    }
                );

                this.box.currencyCode = this.getPresentmentCurrencyCode();

                if (this.oneTimeShippingCostShop != null) {
                    this.oneTimeShippingCost =
                        this.convertShopAmountToPresentment(
                            this.oneTimeShippingCostShop
                        );
                }
            }

            setupBox() {
                const box = this.box;
                this._tiers = null;
                this._oneTimeDiscountBySize = null;

                this.variantsByPlatformId = new Map();
                (box.selectableProductVariants || []).forEach((product) => {
                    (product.productVariants || []).forEach((variant) => {
                        this.variantsByPlatformId.set(variant.platformId, {
                            ...variant,
                            productHandle: product.productHandle,
                            productTitle: product.productTitle,
                            productImageSrc:
                                variant.imageSrc || product.productImageSrc
                        });
                    });
                });

                const tiers = this.getTiers();
                const maxSize = tiers.length
                    ? tiers[tiers.length - 1].size
                    : this.variantsByPlatformId.size;
                this.slots = Array.from({ length: maxSize }, () => null);

                this.planEntries = Object.entries(
                    box.sellingPlanGroup || {}
                ).sort(
                    ([, a], [, b]) =>
                        sellingPlanSortValue(a) - sellingPlanSortValue(b)
                );
                this.purchaseType = this.planEntries.length
                    ? this.planEntries[0][0]
                    : ONE_TIME;

                this.welcomeKitCategories = this.readWelcomeKitConfig();
                this.welcomeKitSelections = new Map(
                    this.welcomeKitCategories.map((category) => [
                        category.categoryName,
                        new Set()
                    ])
                );

                this.restoreSelection();
                this.ensureDefaultWelcomeKitSelections();
                this.rebuildSelectionMetrics();
            }

            getStorageKey() {
                return `skio-dynamic-box:${this.blockId}:${this.productPlatformId}`;
            }

            persistSelection() {
                try {
                    sessionStorage.setItem(
                        this.getStorageKey(),
                        JSON.stringify({
                            slots: this.slots,
                            purchaseType: this.purchaseType,
                            welcomeKit: Array.from(
                                this.welcomeKitSelections.entries()
                            ).map(([categoryName, variantIds]) => [
                                categoryName,
                                Array.from(variantIds)
                            ])
                        })
                    );
                } catch (error) {
                    console.warn(
                        "AtlasSkioDynamicBox: failed to persist selection",
                        error
                    );
                }
            }

            restoreSelection() {
                let saved;
                try {
                    const raw = sessionStorage.getItem(this.getStorageKey());
                    if (!raw) return;
                    saved = JSON.parse(raw);
                } catch (error) {
                    console.warn(
                        "AtlasSkioDynamicBox: failed to restore selection",
                        error
                    );
                    return;
                }
                if (!saved) return;

                if (Array.isArray(saved.slots)) {
                    saved.slots.forEach((variantPlatformId, index) => {
                        if (index >= this.slots.length) return;
                        if (
                            variantPlatformId &&
                            this.variantsByPlatformId.has(variantPlatformId)
                        ) {
                            this.slots[index] = variantPlatformId;
                        }
                    });
                }

                if (
                    saved.purchaseType &&
                    (saved.purchaseType === ONE_TIME ||
                        this.planEntries.some(
                            ([planId]) => planId === saved.purchaseType
                        ))
                ) {
                    this.purchaseType = saved.purchaseType;
                }

                if (Array.isArray(saved.welcomeKit)) {
                    saved.welcomeKit.forEach(([categoryName, variantIds]) => {
                        const selected =
                            this.welcomeKitSelections.get(categoryName);
                        if (!selected || !Array.isArray(variantIds)) return;
                        const category = this.welcomeKitCategories.find(
                            (item) => item.categoryName === categoryName
                        );
                        if (!category) return;

                        const allowedVariantIds = new Set(
                            category.products.map(
                                (product) => product.variantId
                            )
                        );
                        const maxSelections = category.maxSelections || 1;
                        variantIds
                            .map(String)
                            .filter((variantId) =>
                                allowedVariantIds.has(variantId)
                            )
                            .slice(0, maxSelections)
                            .forEach((variantId) => selected.add(variantId));
                    });
                }
            }

            ensureDefaultWelcomeKitSelections() {
                if (!this.welcomeKitCategories.length) return;

                const hasAnySelection = Array.from(
                    this.welcomeKitSelections.values()
                ).some((selected) => selected && selected.size > 0);
                if (hasAnySelection) return;

                this.welcomeKitCategories.forEach((category) => {
                    const selected = this.welcomeKitSelections.get(
                        category.categoryName
                    );
                    if (!selected) return;
                    const firstAvailable = (category.products || []).find(
                        (product) =>
                            product?.variantId && product.available !== false
                    );
                    if (firstAvailable) {
                        selected.add(String(firstAvailable.variantId));
                    }
                });
            }

            readPerksConfig() {
                if (!this.perksId) return {};
                const el = document.getElementById(this.perksId);
                if (!el?.textContent) return {};

                try {
                    return JSON.parse(el.textContent) || {};
                } catch (error) {
                    console.warn(
                        "AtlasSkioDynamicBox: failed to parse perks config",
                        error
                    );
                    return {};
                }
            }

            buildPerksHtml(config) {
                if (!config?.items?.length) return "";

                const isCross = config.style === "cross";
                const modifierClass = isCross
                    ? " skio-dynamic-box__frequency-perks--cross"
                    : "";

                const itemsHtml = config.items
                    .filter(Boolean)
                    .map((item) => {
                        const colorStyle = config.textColor
                            ? ` style="color: ${config.textColor}"`
                            : "";

                        let icon = "";
                        if (config.showIcons) {
                            if (
                                config.customIcon &&
                                config.customIconType === "html" &&
                                config.customIconHtml
                            ) {
                                icon = config.customIconHtml;
                            } else if (
                                config.customIcon &&
                                config.customIconImage
                            ) {
                                const size = config.iconSize || 18;
                                icon = `<img src="${config.customIconImage}" width="${size}" height="${size}" alt="" loading="lazy">`;
                            } else if (isCross) {
                                icon =
                                    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M4.375 4.375L13.125 13.125" stroke="#B42222" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.125 4.375L4.375 13.125" stroke="#B42222" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                            } else {
                                icon =
                                    '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none"><path d="M10.75 0.75L3.875 7.625L0.75 4.5" stroke="#414141" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                            }
                        }

                        return `<span${colorStyle}>${icon}${item}</span>`;
                    })
                    .join("");

                return `<div class="skio-dynamic-box__frequency-perks product-variants-group-info-bottom${modifierClass}">${itemsHtml}</div>`;
            }

            readWelcomeKitConfig() {
                if (!this.welcomeKitId) return [];
                const el = document.getElementById(this.welcomeKitId);
                if (!el?.textContent) return [];

                try {
                    const raw = JSON.parse(el.textContent);
                    if (!Array.isArray(raw)) return [];
                    return raw
                        .filter(
                            (category) =>
                                category?.categoryName &&
                                category.products?.length
                        )
                        .map((category) => ({
                            ...category,
                            products: (category.products || []).map(
                                (product) => ({
                                    ...product,
                                    // Normalize to string: data-variant-id attributes are
                                    // always strings, so selection lookups must match.
                                    variantId: String(product.variantId)
                                })
                            )
                        }));
                } catch (error) {
                    console.warn(
                        "AtlasSkioDynamicBox: failed to parse welcome kit config",
                        error
                    );
                    return [];
                }
            }

            isSubscribing() {
                return this.purchaseType !== ONE_TIME;
            }

            toggleWelcomeKitSelection(categoryName, variantId) {
                const category = this.welcomeKitCategories.find(
                    (c) => c.categoryName === categoryName
                );
                if (!category) return;

                const selected = this.welcomeKitSelections.get(categoryName);
                if (!selected) return;

                const maxSelections = category.maxSelections || 1;
                const previouslySelected = new Set(selected);

                if (selected.has(variantId)) {
                    return;
                } else {
                    if (maxSelections <= 1) selected.clear();
                    if (selected.size >= maxSelections) return;
                    selected.add(variantId);
                }

                this.updateWelcomeKitCategoryUI(
                    categoryName,
                    previouslySelected,
                    selected,
                    maxSelections
                );
                this.renderSummary();
                this.updatePlanPricingUI();
                this.persistSelection();
            }

            updateWelcomeKitCategoryUI(
                categoryName,
                previouslySelected,
                selected,
                maxSelections
            ) {
                const container = this.querySelector("[data-skio-welcome-kit]");
                if (!container) return;

                const categoryEl = Array.from(
                    container.querySelectorAll(
                        ".skio-dynamic-box__welcome-kit-category"
                    )
                ).find(
                    (element) => element.dataset.categoryName === categoryName
                );
                if (!categoryEl) return;

                const countEl = categoryEl.querySelector(
                    "[data-skio-welcome-kit-count]"
                );
                if (countEl) {
                    countEl.textContent = `${selected.size}/${maxSelections}`;
                }

                const affectedVariantIds = new Set([
                    ...previouslySelected,
                    ...selected
                ]);

                affectedVariantIds.forEach((variantId) => {
                    const button = Array.from(
                        categoryEl.querySelectorAll(
                            "[data-skio-welcome-kit-pick]"
                        )
                    ).find(
                        (element) => element.dataset.variantId === variantId
                    );
                    if (!button) return;
                    const isSelected = selected.has(variantId);
                    button.classList.toggle("is-selected", isSelected);
                    const check = button.querySelector(
                        ".skio-dynamic-box__welcome-kit-check"
                    );
                    if (check) {
                        check.innerHTML = isSelected ? CHECKMARK_SVG : "";
                    }
                });
            }

            // The welcome kit as a whole is optional — but once the shopper picks an
            // item in any one category, it's all-or-nothing: every other category
            // then needs a pick too, rather than any category being individually
            // mandatory.
            getUnmetRequiredWelcomeKitCategories() {
                if (!this.isSubscribing()) return [];
                const hasAnySelection = Array.from(
                    this.welcomeKitSelections.values()
                ).some((selected) => selected && selected.size > 0);
                if (!hasAnySelection) return [];
                return this.welcomeKitCategories.filter((category) => {
                    const selected = this.welcomeKitSelections.get(
                        category.categoryName
                    );
                    return !selected || selected.size === 0;
                });
            }

            readCollectionsMap() {
                if (!this.collectionsMapId) return new Map();
                const el = document.getElementById(this.collectionsMapId);
                if (!el?.textContent) return new Map();

                try {
                    const raw = JSON.parse(el.textContent);
                    const map = new Map();
                    Object.entries(raw).forEach(([handle, collection]) => {
                        if (handle === "all" || handle === "frontpage") return;
                        map.set(handle, collection);
                    });
                    return map;
                } catch (error) {
                    console.warn(
                        "AtlasSkioDynamicBox: failed to parse collections map",
                        error,
                        "raw content (first 2000 chars):",
                        el.textContent.slice(0, 2000)
                    );
                    return new Map();
                }
            }

            getByobGroupHandles(collectionsMap) {
                const ordered = [];
                collectionsMap.forEach((collection, handle) => {
                    const order = Number.parseInt(collection.byobOrder, 10);
                    if (!Number.isFinite(order)) return;
                    ordered.push({ handle, order });
                });
                if (!ordered.length) return RANGE_GROUP_HANDLES;
                ordered.sort(
                    (a, b) =>
                        a.order - b.order || a.handle.localeCompare(b.handle)
                );
                return ordered.map((item) => item.handle);
            }

            buildGroups() {
                const box = this.box;
                const products = box.selectableProductVariants || [];

                const handleToTitle = new Map();
                const groupMetaByTitle = new Map();
                const groupTitleOrder = [];
                const productReviewsByHandle = new Map();
                const productTasteInfoByHandle = new Map();
                const productBadgesByHandle = new Map();

                const collectionsMap = this.readCollectionsMap();

                collectionsMap.forEach((collection) => {
                    Object.entries(collection.productReviews || {}).forEach(
                        ([productHandle, review]) => {
                            if (!productReviewsByHandle.has(productHandle)) {
                                productReviewsByHandle.set(
                                    productHandle,
                                    review
                                );
                            }
                        }
                    );
                    Object.entries(collection.productTasteInfo || {}).forEach(
                        ([productHandle, tasteInfo]) => {
                            if (
                                !productTasteInfoByHandle.has(productHandle) &&
                                tasteInfo
                            ) {
                                productTasteInfoByHandle.set(
                                    productHandle,
                                    tasteInfo
                                );
                            }
                        }
                    );
                    Object.entries(collection.productBadges || {}).forEach(
                        ([productHandle, badges]) => {
                            if (
                                badges?.length &&
                                !productBadgesByHandle.has(productHandle)
                            ) {
                                productBadgesByHandle.set(
                                    productHandle,
                                    badges
                                );
                            }
                        }
                    );
                });

                const rangeGroupHandles =
                    this.getByobGroupHandles(collectionsMap);
                rangeGroupHandles.forEach((handle) => {
                    const collection = collectionsMap.get(handle);
                    if (!collection) return;

                    groupTitleOrder.push(collection.title);
                    groupMetaByTitle.set(collection.title, {
                        shortDescription: collection.shortDescription || "",
                        supports: (collection.supports || []).filter(Boolean)
                    });
                    (collection.productHandles || []).forEach(
                        (productHandle) => {
                            if (!handleToTitle.has(productHandle)) {
                                handleToTitle.set(
                                    productHandle,
                                    collection.title
                                );
                            }
                        }
                    );
                });

                this.handleToGroupTitle = handleToTitle;
                this.productReviewsByHandle = productReviewsByHandle;
                this.productTasteInfoByHandle = productTasteInfoByHandle;
                this.productBadgesByHandle = productBadgesByHandle;

                const groupedByTitle = new Map();
                products.forEach((product) => {
                    const title =
                        handleToTitle.get(product.productHandle) ||
                        OTHER_GROUP_TITLE;
                    if (!groupedByTitle.has(title))
                        groupedByTitle.set(title, []);
                    groupedByTitle.get(title).push(product);
                });

                // Best Sellers products surface first within whatever group they
                // landed in — Array#sort is stable, so non-bestsellers keep their
                // relative order.
                groupedByTitle.forEach((groupProducts) => {
                    groupProducts.sort((a, b) => {
                        const aIsBestSeller = productBadgesByHandle.has(
                            a.productHandle
                        );
                        const bIsBestSeller = productBadgesByHandle.has(
                            b.productHandle
                        );
                        return aIsBestSeller === bIsBestSeller
                            ? 0
                            : aIsBestSeller
                              ? -1
                              : 1;
                    });
                });

                const orderedTitles = [
                    ...new Set([...groupTitleOrder, OTHER_GROUP_TITLE])
                ];

                this.groups = orderedTitles
                    .filter((title) => groupedByTitle.has(title))
                    .map((title) => ({
                        title,
                        products: groupedByTitle.get(title),
                        shortDescription:
                            groupMetaByTitle.get(title)?.shortDescription || "",
                        supports: groupMetaByTitle.get(title)?.supports || []
                    }));

                this.openGroups = new Set(
                    this.groups.length ? [this.groups[0].title] : []
                );
            }

            // The smallest configured tier is the minimum number of items the whole
            // box requires before it can be added to cart (e.g. "2 Pack" minimum).
            getMinimumBoxSize() {
                return this.getTiers()[0]?.size || 1;
            }

            // Each product carries one real Shopify variant per pack-size tier (e.g.
            // "1 PACK"/"2 PACK"/"4 PACK") — every box slot represents a single unit
            // of that product, so it must always add the "1 PACK" variant regardless
            // of which tier the box as a whole lands in. `productVariants[0]` isn't
            // reliably that one (Skio doesn't guarantee array order), which is why
            // the cart line item was showing whatever pack size happened to be
            // first (e.g. "2 PACK") no matter how many units were actually added.
            getSingleUnitVariant(product) {
                const variants = product.productVariants || [];
                return (
                    variants.find(
                        (variant) =>
                            (variant.productVariantTitle || "")
                                .trim()
                                .toUpperCase() === "1 PACK"
                    ) || variants[0]
                );
            }

            getTiers() {
                if (this._tiers) return this._tiers;

                const box = this.box;
                if (!box) return [];

                const percentSource = box.percentDiscountTier;
                const fixedSource = box.fixedDiscountTier;
                const source = percentSource || fixedSource;
                if (!source) return [];

                this._tiers = Object.entries(source)
                    .map(([size, value]) => ({
                        size: parseInt(size, 10),
                        value: parseFloat(value)
                    }))
                    .filter((tier) => !Number.isNaN(tier.size))
                    .sort((a, b) => a.size - b.size)
                    .map((tier, index, all) => ({
                        ...tier,
                        isPercent: Boolean(percentSource),
                        isBestValue: index === all.length - 1
                    }));

                return this._tiers;
            }

            getOneTimeDiscountPercentForSize(size) {
                const api = window.atlasOtpByobDiscount;
                if (api && typeof api.percentForSize === "function") {
                    const fromApi = Number(api.percentForSize(size));
                    if (Number.isFinite(fromApi)) return Math.max(0, fromApi);
                }
                return otpByobPercentForSize(size, api?.percents);
            }

            getActivePlan() {
                if (this.purchaseType === ONE_TIME) return null;
                return this.box?.sellingPlanGroup?.[this.purchaseType] || null;
            }

            getSubscriptionDiscountPercent(plan) {
                if (!plan) return 0;
                if (plan.priceAdjustmentType === "PERCENTAGE") {
                    return Number(plan.priceAdjustmentAmount) || 0;
                }
                return 0;
            }

            getBasePrice() {
                return this._basePrice;
            }

            getUnitPriceForSize(size, basePrice, plan) {
                const tiers = this.getTiers();
                const tier = tiers.find((t) => t.size === size);
                const base = roundMoney(basePrice);

                if (!plan) {
                    return applyPercentOff(
                        base,
                        this.getOneTimeDiscountPercentForSize(size)
                    );
                }

                const subPercent = this.getSubscriptionDiscountPercent(plan);
                const effectiveBase = applyPercentOff(base, subPercent);

                if (!tier) return effectiveBase;

                if (tier.isPercent) {
                    return applyPercentOff(effectiveBase, tier.value);
                }

                return roundMoney(effectiveBase - tier.value / size);
            }

            getPercentSaved(size, basePrice, plan) {
                if (!basePrice) {
                    const tiers = this.getTiers();
                    const tier = tiers.find((t) => t.size === size);
                    if (!plan) {
                        return Math.max(
                            0,
                            Math.round(
                                this.getOneTimeDiscountPercentForSize(size)
                            )
                        );
                    }
                    if (tier?.isPercent) {
                        const subPercent =
                            this.getSubscriptionDiscountPercent(plan);
                        const combined =
                            1 - (1 - subPercent / 100) * (1 - tier.value / 100);
                        return Math.max(0, Math.round(combined * 100));
                    }
                    return 0;
                }
                const unitPrice = this.getUnitPriceForSize(
                    size,
                    basePrice,
                    plan
                );
                return Math.max(
                    0,
                    Math.round((1 - unitPrice / basePrice) * 100)
                );
            }

            getFilledCount() {
                return this._filledCount;
            }

            getCountForVariant(platformId) {
                return this._variantCounts.get(platformId) || 0;
            }

            rebuildSelectionMetrics() {
                const counts = new Map();
                let totalPrice = 0;
                let selectedCount = 0;

                this.slots.forEach((platformId) => {
                    if (!platformId) return;
                    selectedCount += 1;
                    counts.set(platformId, (counts.get(platformId) || 0) + 1);
                    totalPrice +=
                        Number(
                            this.variantsByPlatformId.get(platformId)?.price
                        ) || 0;
                });

                let priceDivisor = selectedCount;
                if (!selectedCount) {
                    // Empty box: use the average 1 PACK unit price so tier/frequency
                    // previews are meaningful, instead of averaging every pack size.
                    const unitPrices = (
                        this.box?.selectableProductVariants || []
                    )
                        .map((product) => this.getSingleUnitVariant(product))
                        .filter(Boolean)
                        .map((variant) => Number(variant.price) || 0)
                        .filter((price) => price > 0);
                    totalPrice = unitPrices.reduce(
                        (sum, price) => sum + price,
                        0
                    );
                    priceDivisor = unitPrices.length;
                }

                this._variantCounts = counts;
                this._filledCount = selectedCount;
                this._basePrice = priceDivisor
                    ? roundMoney(totalPrice / priceDivisor)
                    : 0;
            }

            addVariant(variantPlatformId) {
                const index = this.slots.findIndex((slot) => slot === null);
                if (index === -1) return false;
                this.slots[index] = variantPlatformId;
                this.onSelectionChanged();
                return true;
            }

            removeVariant(variantPlatformId) {
                const index = this.slots.lastIndexOf(variantPlatformId);
                if (index === -1) return;
                this.slots[index] = null;
                this.onSelectionChanged();
            }

            clearSlot(index) {
                if (index < 0 || index >= this.slots.length) return;
                this.slots[index] = null;
                this.onSelectionChanged();
            }

            // Keeps filled slots packed at the front (in their existing relative
            // order) so empty "+" slots always end up last, regardless of which
            // slot index was removed.
            compactSlots() {
                const filled = this.slots.filter((slot) => slot !== null);
                const emptyCount = this.slots.length - filled.length;
                this.slots = filled.concat(Array(emptyCount).fill(null));
            }

            onSelectionChanged() {
                this.compactSlots();
                this.rebuildSelectionMetrics();
                this.updatePlanPricingUI();
                this.renderTiers();
                this.renderSlots();
                this.updateGroupsSelectionUI();
                this.renderSummary();
                this.persistSelection();
            }

            render() {
                const box = this.box;
                if (!box) return;

                this.innerHTML = `
            <div class="skio-dynamic-box">
                <div class="skio-dynamic-box__sticky-area">
                    <div class="skio-dynamic-box__panel">
                        <div class="skio-dynamic-box__tiers" data-skio-tiers></div>
                        <div class="skio-dynamic-box__box" data-skio-box>
                            <button type="button" class="skio-dynamic-box__box-toggle" data-skio-toggle>
                                <span class="skio-dynamic-box__box-toggle-label">Your Bundle:</span>
                                <span data-skio-count></span>
                                <span class="skio-dynamic-box__chevron" data-skio-chevron>${CHEVRON_DOWN_SVG}</span>
                            </button>
                            <div class="skio-dynamic-box__slots" data-skio-slots></div>
                        </div>
                    </div>
                    <h4 class="skio-dynamic-box__groups-heading">
                        1. Select up to ${this.slots.length} products
                    </h4>
                    <div class="skio-dynamic-box__groups" data-skio-groups></div>
                    <h4 class="skio-dynamic-box__groups-heading">
                        2. Select Frequency:
                    </h4>
                    <div class="skio-dynamic-box__plans" data-skio-plans></div>
                </div>
                <div class="skio-dynamic-box__summary" data-skio-summary></div>
                <button type="button" class="btn btn-primary skio-dynamic-box__submit" data-skio-submit>
                    ${this.buttonLabel}
                </button>
                <p class="skio-dynamic-box__error" data-skio-error hidden></p>
            </div>
        `;

                this.renderPlans();
                this.renderTiers();
                this.renderSlots();
                this.renderGroups();
                this.renderWelcomeKit();
                this.renderSummary();
                this.setupStickyObserver();
            }

            openQuickViewPopup(popup, trigger) {
                if (!popup) return;
                if (
                    popup.hasAttribute("open") &&
                    !popup.classList.contains("is-closing")
                ) {
                    return;
                }

                const opener = this.querySelector("atlas-link-and-popup");
                if (opener && typeof opener.showPopup === "function") {
                    opener.triggerElement = trigger;
                    opener.showPopup();
                    return;
                }

                popup.classList.remove("is-closing");
                popup.openedBy = trigger;
                document.body.classList.add("overflow-hidden");
                popup.setAttribute("open", "");
                window.pauseAllMedia?.();
            }

            showQuickView(button) {
                if (!this.quickViewId) return;
                const popup = document.querySelector(
                    `#AtlasPopup-${this.quickViewId}`
                );
                const content = popup?.querySelector(
                    "[data-skio-quick-view-content]"
                );
                if (!content) return;
                const actions = popup.querySelector(
                    "[data-skio-quick-view-actions]"
                );

                const platformId = button.getAttribute("data-platform-id");

                content.innerHTML =
                    '<div class="skio-dynamic-box__quick-view-loading">Loading…</div>';

                const productUrl = button.getAttribute("data-product-url");
                if (!productUrl) {
                    content.innerHTML =
                        "<p>Unable to load product details.</p>";
                    return;
                }

                this.openQuickViewPopup(popup, button);

                this._quickViewRequestController?.abort();
                this.disconnectQuickViewActionsVisibility();
                const controller = new AbortController();
                this._quickViewRequestController = controller;

                const cachedHtml = this._quickViewHtmlCache.get(productUrl);
                const responseTextPromise = cachedHtml
                    ? Promise.resolve(cachedHtml)
                    : fetch(productUrl, { signal: controller.signal })
                          .then((response) => {
                              if (!response.ok) {
                                  throw new Error(
                                      `Product page responded with ${response.status}`
                                  );
                              }
                              return response.text();
                          })
                          .then((responseText) => {
                              this._quickViewHtmlCache.set(
                                  productUrl,
                                  responseText
                              );
                              return responseText;
                          });

                responseTextPromise
                    .then((responseText) => {
                        if (controller.signal.aborted || !content.isConnected)
                            return;
                        const responseHTML = new DOMParser().parseFromString(
                            responseText,
                            "text/html"
                        );
                        // Pull just the atlas-slider (product images) — not the
                        // desktop/mobile-only ".product-media-gallery" grid variant
                        // some product pages render instead of/alongside it — plus
                        // the content group (collections/title/reviews/description/
                        // supports) and the info accordion. Not the full page.
                        const slider = responseHTML.querySelector(
                            ".product-media-group atlas-slider"
                        );
                        // atlas.product.media.liquid emits a <style> tag scoping
                        // --ratio/--aspect-ratio/--border-* to ".product-media-{id}"
                        // as a sibling of atlas-slider (both children of
                        // ".product-media-group") — not a descendant of the slider —
                        // so it's missed unless pulled in separately.
                        const mediaStyle = responseHTML.querySelector(
                            ".product-media-group > style"
                        );
                        const contentGroup = responseHTML.querySelector(
                            ".product-content-group"
                        );
                        const accordion =
                            responseHTML.querySelector("atlas-accordion");

                        if (!slider && !contentGroup && !accordion) {
                            content.innerHTML =
                                "<p>Unable to load product details.</p>";
                            return;
                        }

                        // The slider markup is normally scoped to one device via
                        // "mobile-hidden"/"desktop-hidden" (the other device gets the
                        // gallery grid instead). In the popup we always want the
                        // slider, on both devices, so drop those scoping classes.
                        if (slider) {
                            slider.classList.remove(
                                "mobile-hidden",
                                "desktop-hidden"
                            );
                            slider.setAttribute(
                                "data-slides-per-view-desktop",
                                "1"
                            );
                            // The naturopath "A/B test" slide is normally hidden via
                            // CSS scoped to ".section-main-product" (both the main
                            // slide and its matching thumb in .slider-thumbs). That
                            // ancestor is never recreated in the popup, so both must
                            // be stripped from the DOM here instead of relying on CSS.
                            // NOTE: raw fetched HTML is pre-Swiper-init, so these
                            // elements only have the "swiper-slide" *tag*, not yet
                            // the "swiper-slide" *class* Swiper adds at runtime —
                            // closest() must match on the tag, not a class selector.
                            slider
                                .querySelectorAll(
                                    "swiper-slide:has(.product-media-naturopath), .product-media-naturopath, .slider-thumbs-extra-slide--ab-test"
                                )
                                .forEach((slide) => {
                                    const slideEl =
                                        slide.closest("swiper-slide") || slide;
                                    slideEl.remove();
                                });
                        }

                        // Do every fixup below on a *detached* wrapper (still owned
                        // by the parsed, inert responseHTML document) BEFORE it's
                        // ever inserted into the live document — custom elements
                        // (atlas-accordion, atlas-slider) upgrade and run their
                        // connectedCallback synchronously the instant they're
                        // inserted live, so any attribute fix applied afterward is
                        // too late.
                        const wrapper = responseHTML.createElement("div");
                        // ".product-container" here reuses the slider styling from
                        // atlas.block.product.container.css, which is scoped to
                        // ".product-container .media-group .product-media-group" —
                        // recreating that ancestry avoids duplicating slider CSS
                        // just for the popup.
                        wrapper.className =
                            "skio-dynamic-box__quick-view-body product-container";
                        if (slider) {
                            // Badge positioning (.badges-group.badges-position) and
                            // the slider's own sizing rules are scoped to a
                            // ".product-media-group" ancestor (position: relative
                            // context) on real product pages — recreate it here so
                            // product-badges (rendered inside the first slide) and
                            // the slider itself lay out correctly.
                            const mediaGroupOuter =
                                responseHTML.createElement("div");
                            mediaGroupOuter.className = "media-group";
                            const mediaGroup =
                                responseHTML.createElement("div");
                            mediaGroup.className = "product-media-group";
                            if (mediaStyle) mediaGroup.appendChild(mediaStyle);
                            mediaGroup.appendChild(slider);
                            mediaGroupOuter.appendChild(mediaGroup);
                            wrapper.appendChild(mediaGroupOuter);
                        }
                        if (contentGroup) wrapper.appendChild(contentGroup);
                        if (accordion) {
                            // Mirrors the real product page, where atlas-accordion
                            // sits inside a ".product-content-additional-info-group"
                            // wrapper (see atlas.product.content.additional-info-group.liquid).
                            const additionalInfoGroup =
                                responseHTML.createElement("div");
                            additionalInfoGroup.className =
                                "product-content-additional-info-group";
                            additionalInfoGroup.appendChild(accordion);
                            wrapper.appendChild(additionalInfoGroup);
                        }
                        // Move the (still-live) actions element into this same
                        // wrapper — appendChild across documents adopts it, removing
                        // it from its current spot in the popup.
                        if (actions) wrapper.appendChild(actions);

                        // Taste info: shown only in this quick-view popup, between
                        // reviews and description — sourced from the collections map
                        // JSON (built server-side from product.metafields.custom.taste_info)
                        // rather than the fetched product page, so it works even if
                        // the PDP itself doesn't render a taste-info block.
                        if (contentGroup) {
                            const productHandle = productUrl
                                .split("/products/")[1]
                                ?.split(/[?#]/)[0];
                            const tasteInfo =
                                productHandle &&
                                this.productTasteInfoByHandle?.get(
                                    productHandle
                                );
                            if (tasteInfo) {
                                const tasteInfoEl =
                                    responseHTML.createElement("div");
                                tasteInfoEl.className =
                                    "skio-dynamic-box__taste-info";
                                tasteInfoEl.innerHTML = tasteInfo;
                                const descriptionEl =
                                    contentGroup.querySelector(
                                        "product-description"
                                    );
                                const reviewsEl =
                                    contentGroup.querySelector(
                                        "product-reviews"
                                    );
                                if (descriptionEl) {
                                    descriptionEl.before(tasteInfoEl);
                                } else if (reviewsEl) {
                                    reviewsEl.after(tasteInfoEl);
                                } else {
                                    contentGroup.appendChild(tasteInfoEl);
                                }
                            }
                        }

                        // Not wanted in the quick view popup.
                        wrapper
                            .querySelectorAll(
                                "product-stitching, product-consumer-information"
                            )
                            .forEach((el) => el.remove());

                        // atlas-accordion scrolls the whole page (window.scrollTo) to
                        // bring the opened item into view — inside our fixed popup
                        // that just scrolls the page behind it. Disable that here.
                        wrapper
                            .querySelectorAll("atlas-accordion")
                            .forEach((el) => {
                                el.setAttribute(
                                    "data-accordion-scroll-mobile",
                                    "false"
                                );
                                el.setAttribute(
                                    "data-accordion-scroll-desktop",
                                    "false"
                                );
                            });

                        // Single live-DOM mutation: everything above already
                        // happened on the detached wrapper.
                        content.innerHTML = "";
                        content.appendChild(wrapper);

                        // atlas-slider initializes itself in connectedCallback, but
                        // guard against it having missed the swiper-container child
                        // (e.g. registered after this element connected) by forcing
                        // a re-init once it's actually live in the document.
                        const liveSlider =
                            content.querySelector("atlas-slider");
                        if (
                            liveSlider &&
                            typeof liveSlider.refresh === "function"
                        ) {
                            liveSlider.refresh();
                        }
                        this.enlargePopupThumbnails(liveSlider);

                        this.renderQuickViewActions(popup, platformId);
                        this.initQuickViewReviews(content);
                        this.observeQuickViewActionsVisibility(
                            wrapper,
                            actions
                        );
                    })
                    .catch((error) => {
                        if (error.name === "AbortError") return;
                        console.error(
                            "AtlasSkioDynamicBox: quick view failed to load",
                            error
                        );
                        content.innerHTML =
                            "<p>Unable to load product details.</p>";
                    })
                    .finally(() => {
                        if (this._quickViewRequestController === controller) {
                            this._quickViewRequestController = null;
                        }
                    });
            }

            // The gallery thumbnails swiper is shared code (atlas.slider.js) whose
            // sizing is tuned for the full-width product page — in this narrower
            // popup the same slidesPerView produces ~32px thumbs. Force the swiper's
            // own params directly on this specific instance (found by walking down
            // from the slider element we just inserted, never via a global
            // selector) so we can't be misled by another matching slider elsewhere
            // on the page, then re-apply on resize since Swiper's breakpoints would
            // otherwise revert it.
            enlargePopupThumbnails(sliderEl) {
                const thumbsSwiperEl = sliderEl?.querySelector(
                    ".slider-thumbs swiper-container"
                );
                if (!thumbsSwiperEl) return;

                const apply = () => {
                    const swiper = thumbsSwiperEl.swiper;
                    if (!swiper) return;
                    const isDesktop = window.matchMedia(
                        "(min-width: 1024px)"
                    ).matches;
                    const slidesPerView = 6;
                    const spaceBetween = isDesktop ? 8 : 4;

                    swiper.params.slidesPerView = slidesPerView;
                    swiper.params.spaceBetween = spaceBetween;
                    if (swiper.originalParams) {
                        swiper.originalParams.slidesPerView = slidesPerView;
                        swiper.originalParams.spaceBetween = spaceBetween;
                        const breakpoint =
                            swiper.originalParams.breakpoints?.[1024];
                        if (breakpoint) {
                            breakpoint.slidesPerView = 6;
                            breakpoint.spaceBetween = 8;
                        }
                    }
                    swiper.update();
                };

                if (thumbsSwiperEl.swiper) {
                    apply();
                } else {
                    const start = Date.now();
                    const waitForSwiper = () => {
                        if (!thumbsSwiperEl.isConnected) {
                            return;
                        } else if (thumbsSwiperEl.swiper) {
                            apply();
                        } else if (Date.now() - start < 2000) {
                            setTimeout(waitForSwiper, 50);
                        }
                    };
                    waitForSwiper();
                }

                if (!this._popupThumbsResizeHandler) {
                    this._popupThumbsResizeHandler = () =>
                        this.enlargePopupThumbnails(
                            document.querySelector(
                                `#AtlasPopup-${this.quickViewId} [data-skio-quick-view-content] atlas-slider`
                            )
                        );
                    window.addEventListener(
                        "resize",
                        this._popupThumbsResizeHandler
                    );
                }
            }

            initQuickViewReviews(content) {
                const looxEl = content.querySelector(".loox-rating");
                if (!looxEl) return;

                const alreadyRendered = () =>
                    !!looxEl.querySelector(".loox-rating-content");

                // The popup shows Loox's own markup verbatim, exactly like the PDP.
                // Loox does sometimes pick up dynamically-inserted elements on its
                // own, just not immediately — only fall back to our own markup if it
                // hasn't rendered after a short wait.
                if (alreadyRendered()) return;

                const observer = new MutationObserver(() => {
                    if (alreadyRendered()) {
                        observer.disconnect();
                        clearTimeout(fallbackTimer);
                    }
                });
                observer.observe(looxEl, { childList: true, subtree: true });

                const fallbackTimer = setTimeout(() => {
                    observer.disconnect();
                    if (!looxEl.isConnected) return;
                    if (alreadyRendered()) return;
                    this.renderLooxFallback(looxEl);
                }, 1200);
            }

            // Loox's own label only shows "(95)" (per its data-pattern config) — add
            // the numeric rating + "N REVIEWS" text alongside it, without touching
            // Loox's own generated markup.
            enhanceLooxWidget(looxEl) {
                const content = looxEl.querySelector(".loox-rating-content");
                if (
                    !content ||
                    content.querySelector(
                        ".skio-dynamic-box__loox-rating-extra"
                    )
                ) {
                    return;
                }

                const rating =
                    parseFloat(looxEl.getAttribute("data-rating")) || 0;
                const raters =
                    parseInt(looxEl.getAttribute("data-raters"), 10) || 0;
                if (!rating || !raters) return;

                content.insertAdjacentHTML(
                    "beforeend",
                    `
                <span class="skio-dynamic-box__loox-rating-extra">
                    <span class="skio-dynamic-box__loox-fallback-rating">${rating.toFixed(1)}</span>
                    <span class="skio-dynamic-box__loox-fallback-count">${raters} REVIEWS</span>
                </span>
            `
                );
            }

            renderLooxFallback(looxEl) {
                const rating =
                    parseFloat(looxEl.getAttribute("data-rating")) || 0;
                const raters =
                    parseInt(looxEl.getAttribute("data-raters"), 10) || 0;

                if (!raters) {
                    looxEl.closest("product-reviews")?.remove();
                    return;
                }

                const percent = Math.max(0, Math.min(100, (rating / 5) * 100));
                const starsRow = Array.from({ length: 5 })
                    .map(() => STAR_SVG)
                    .join("");

                looxEl.outerHTML = `
            <div class="skio-dynamic-box__loox-fallback">
                <div class="skio-dynamic-box__loox-fallback-stars">
                    <div class="skio-dynamic-box__loox-fallback-stars-track">${starsRow}</div>
                    <div class="skio-dynamic-box__loox-fallback-stars-fill" style="width: ${percent}%">${starsRow}</div>
                </div>
                <span class="skio-dynamic-box__loox-fallback-rating">${rating.toFixed(1)}</span>
                <span class="skio-dynamic-box__loox-fallback-count">${raters} REVIEWS</span>
            </div>
        `;
            }

            renderQuickViewActions(popup, platformId) {
                const actions = popup?.querySelector(
                    "[data-skio-quick-view-actions]"
                );
                if (!actions || !platformId) return;

                const count = this.getCountForVariant(platformId);
                const maxReached = this.getFilledCount() >= this.slots.length;
                const disableAdd = maxReached && count === 0;

                actions.innerHTML =
                    count > 0
                        ? `
                    <div class="skio-dynamic-box__stepper">
                        <button type="button" data-skio-decrement data-platform-id="${platformId}" aria-label="Decrease quantity">${MINUS_SVG}</button>
                        <span>${count}</span>
                        <button type="button" data-skio-increment data-platform-id="${platformId}" aria-label="Increase quantity" ${maxReached ? "disabled" : ""}>${PLUS_SVG}</button>
                    </div>
                `
                        : `<button type="button" class="skio-dynamic-box__add-btn" data-skio-increment data-platform-id="${platformId}" ${disableAdd ? "disabled" : ""}>Add to Bundle</button>`;

                actions
                    .querySelectorAll("[data-skio-increment]")
                    .forEach((btn) => {
                        btn.addEventListener("click", (event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.addVariant(
                                btn.getAttribute("data-platform-id")
                            );
                            this.renderQuickViewActions(popup, platformId);
                        });
                    });

                actions
                    .querySelectorAll("[data-skio-decrement]")
                    .forEach((btn) => {
                        btn.addEventListener("click", (event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.removeVariant(
                                btn.getAttribute("data-platform-id")
                            );
                            this.renderQuickViewActions(popup, platformId);
                        });
                    });
            }

            // Flags the popup body while its own add-to-bundle/stepper button
            // (now `position: sticky; bottom: 0`) is actually pinned over
            // still-unscrolled content, so a separating shadow can be styled
            // off this class only while the CTA is floating above something.
            // Once the user scrolls all the way to the end, the button settles
            // back into the flow flush with the bottom and the shadow is removed.
            //
            // Uses a manual scroll-position check (scroll/resize) instead of
            // IntersectionObserver: the popup is still mid open-transition and
            // its images are still loading when this is set up, and
            // IntersectionObserver's first callback can land before that layout
            // has settled — on desktop that showed up as the class never
            // appearing until a scroll forced a recompute. It also can't tell
            // "stuck" apart from "visible" once the CTA is sticky, since a
            // stuck element's rect is always within the viewport.
            observeQuickViewActionsVisibility(wrapper, actions) {
                this.disconnectQuickViewActionsVisibility();
                if (!wrapper || !actions) return;

                const scrollRoot = wrapper.closest(
                    ".atlas-popup-modal__content-wrapper"
                );
                if (!scrollRoot) return;

                const check = () => {
                    const remaining =
                        scrollRoot.scrollHeight -
                        scrollRoot.scrollTop -
                        scrollRoot.clientHeight;
                    const isStuck = remaining > 1;
                    wrapper.classList.toggle(
                        "skio-dynamic-box__quick-view-body--actions-visible",
                        isStuck
                    );
                };

                this._quickViewActionsCheck = check;
                this._quickViewActionsScrollRoot = scrollRoot;
                scrollRoot.addEventListener("scroll", check, {
                    passive: true
                });
                window.addEventListener("resize", check);

                // Images/slider/reviews inside the popup keep resizing the
                // scroller well after this is first wired up (lazy image
                // loads, swiper re-init, accordion content) — none of that
                // fires "scroll" or "resize", so without this the class can
                // get stuck never-added even though the content ends up
                // taller than the popup.
                if (typeof ResizeObserver !== "undefined") {
                    const resizeObserver = new ResizeObserver(check);
                    resizeObserver.observe(scrollRoot);
                    resizeObserver.observe(wrapper);
                    this._quickViewActionsResizeObserver = resizeObserver;
                }

                requestAnimationFrame(() => requestAnimationFrame(check));
            }

            disconnectQuickViewActionsVisibility() {
                if (this._quickViewActionsResizeObserver) {
                    this._quickViewActionsResizeObserver.disconnect();
                    this._quickViewActionsResizeObserver = null;
                }
                if (this._quickViewActionsCheck) {
                    this._quickViewActionsScrollRoot?.removeEventListener(
                        "scroll",
                        this._quickViewActionsCheck
                    );
                    window.removeEventListener(
                        "resize",
                        this._quickViewActionsCheck
                    );
                    this._quickViewActionsCheck = null;
                    this._quickViewActionsScrollRoot = null;
                }
            }

            setupStickyObserver() {
                window.removeEventListener("scroll", this.handleStickyCheck);
                window.removeEventListener("resize", this.handleStickyResize);
                if (this._stickyFrame != null) {
                    cancelAnimationFrame(this._stickyFrame);
                    this._stickyFrame = null;
                }

                const panel = this.querySelector(".skio-dynamic-box__panel");
                if (!panel) return;

                const summaryEl = this.querySelector(
                    ".skio-dynamic-box__summary"
                );

                // Tracks the summary's actual viewport visibility rather than
                // its distance from the panel — the panel starts fading once
                // the summary is visible, and is restored once the summary
                // leaves the viewport again. IntersectionObserver (vs. a
                // getBoundingClientRect check inside updateStickyState)
                // avoids flicker at the boundary: its threshold crossing is
                // reported once per state change, not recomputed every
                // scroll frame against a fuzzy gap.
                //
                // On desktop the trigger point is pulled up by 100px from
                // the bottom of the viewport, so the panel hides once the
                // summary is ~100px away from the bottom of the screen
                // rather than only once it's fully on screen. Mobile keeps
                // the plain "any part visible" trigger.
                const createSummaryObserver = () => {
                    this._summaryVisibilityObserver?.disconnect();
                    this._summaryVisibilityObserver = null;
                    if (!summaryEl) return;
                    const isDesktop =
                        window.matchMedia("(min-width: 769px)").matches;
                    this._summaryVisibilityObserver = new IntersectionObserver(
                        ([entry]) => {
                            panel.classList.toggle(
                                "is-summary-visible",
                                entry.isIntersecting
                            );
                        },
                        {
                            threshold: 0,
                            rootMargin: isDesktop
                                ? "0px 0px -100px 0px"
                                : "0px"
                        }
                    );
                    this._summaryVisibilityObserver.observe(summaryEl);
                };
                createSummaryObserver();

                this._summaryVisibilityMql?.removeEventListener(
                    "change",
                    this._handleSummaryVisibilityMqlChange
                );
                this._summaryVisibilityMql = window.matchMedia(
                    "(min-width: 769px)"
                );
                this._handleSummaryVisibilityMqlChange = createSummaryObserver;
                this._summaryVisibilityMql.addEventListener(
                    "change",
                    this._handleSummaryVisibilityMqlChange
                );

                const updateStickyState = () => {
                    this._stickyFrame = null;
                    // Below 768px the header can collapse (see
                    // `body:has(.shopify-section-header-collapsed)` in
                    // atlas.block.skio-dynamic-box.css), which shifts the
                    // panel's `top`. Comparing against a threshold that
                    // moves together with the value it's being compared to
                    // would never let isStuck flip back to false, so that
                    // range uses a threshold cached once while the header
                    // isn't collapsed (see handleStickyResize). Above that
                    // width nothing ever changes `top`, so reading it live
                    // is safe — and necessary: caching it once at setup can
                    // race the sticky-header's own init (which sets
                    // --header-height that this `top` depends on), baking
                    // in a too-small threshold that only matches once the
                    // panel has nearly scrolled past entirely.
                    const isDesktop =
                        window.matchMedia("(min-width: 769px)").matches;
                    const stickyTop = isDesktop
                        ? Number.parseFloat(getComputedStyle(panel).top) || 0
                        : this._stickyTop;
                    const rect = panel.getBoundingClientRect();
                    // rect.bottom > 0 excludes the panel having already scrolled
                    // past its own container's end: once that happens it moves
                    // with the page again and rect.top drifts to large negative
                    // values, which would otherwise still satisfy `<= stickyTop`
                    // and leave `is-stuck` stuck on forever.
                    const isStuck =
                        rect.top <= stickyTop + 0.5 && rect.bottom > 0;
                    panel.classList.toggle("is-stuck", isStuck);
                };

                this.handleStickyCheck = () => {
                    if (this._stickyFrame != null) return;
                    this._stickyFrame =
                        requestAnimationFrame(updateStickyState);
                };
                this.handleStickyResize = () => {
                    // Only recompute while the header isn't collapsed, so a resize
                    // firing mid-collapse can't bake the shrunk cosmetic top value
                    // into the cached threshold.
                    if (
                        !document.querySelector(
                            ".shopify-section-header-collapsed"
                        )
                    ) {
                        this._stickyTop =
                            Number.parseFloat(getComputedStyle(panel).top) || 0;
                    }
                    this.handleStickyCheck();
                };

                window.addEventListener("scroll", this.handleStickyCheck, {
                    passive: true
                });
                window.addEventListener("resize", this.handleStickyResize);
                this.handleStickyResize();

                // Keeps --skio-sticky-offset in sync with the panel's real
                // position/height, so .skio-dynamic-box__group-header's
                // scroll-margin-top (atlas.block.skio-dynamic-box.css) can
                // push a just-opened group's header clear of the panel above
                // it, regardless of how tall the panel currently is (slot
                // fill state, breakpoint) or whether it's sticky at all on
                // the current viewport. Set on `this` rather than
                // document.documentElement — the property inherits down to
                // .skio-dynamic-box__group-header either way, but scoping it
                // here means no cleanup is needed beyond what
                // disconnectedCallback already does for this component.
                const updateStickyOffset = () => {
                    if (!panel.isConnected) return;
                    const cs = getComputedStyle(panel);
                    const gap = window.matchMedia("(max-width: 768px)").matches
                        ? 40
                        : 24;
                    // On mobile the header can reveal (see sticky-header in
                    // sections/header.liquid) right after this is computed —
                    // often because the settle scroll itself is enough
                    // movement to trigger it — which grows the panel's own
                    // `top` without resizing the panel, so the offset used
                    // below would otherwise fall short. Add the header's
                    // height as a flat buffer so there's always room for it,
                    // whether or not it's visible right now.
                    let headerHeight =
                        Number.parseFloat(
                            getComputedStyle(
                                document.documentElement
                            ).getPropertyValue("--header-height")
                        ) || 0;
                    headerHeight = headerHeight - 85;

                    const offset =
                        cs.position === "sticky"
                            ? (Number.parseFloat(cs.top) || 0) +
                              panel.offsetHeight +
                              gap +
                              headerHeight
                            : 0;
                    this.style.setProperty(
                        "--skio-sticky-offset",
                        `${Math.round(offset)}px`
                    );
                };
                this._stickyPanelResizeObserver?.disconnect();
                this._stickyPanelResizeObserver = new ResizeObserver(
                    updateStickyOffset
                );
                this._stickyPanelResizeObserver.observe(panel);
                this._stickyOffsetMql?.removeEventListener(
                    "change",
                    this._handleStickyOffsetChange
                );
                this._stickyOffsetMql = window.matchMedia("(max-width: 768px)");
                this._handleStickyOffsetChange = updateStickyOffset;
                this._stickyOffsetMql.addEventListener(
                    "change",
                    this._handleStickyOffsetChange
                );
                updateStickyOffset();

                this._frequencyBannerMql =
                    window.matchMedia("(min-width: 768px)");
                this.handleFrequencyBannerBreakpointChange = () =>
                    this.updatePlanPricingUI();
                this._frequencyBannerMql.addEventListener(
                    "change",
                    this.handleFrequencyBannerBreakpointChange
                );
            }

            disconnectedCallback() {
                this.removeEventListener("click", this.handleRootClick);
                this.removeEventListener("change", this.handleRootChange);
                this.removeEventListener(
                    "transitionend",
                    this.handleGroupTransitionEnd
                );
                if (this.handleOtpByobDiscountReady) {
                    document.removeEventListener(
                        "atlas:otp-byob-discount-ready",
                        this.handleOtpByobDiscountReady
                    );
                }
                clearTimeout(this._groupScrollSettleTimer);
                this._pendingGroupScrollToggle = null;
                // Invalidates any in-flight settleGroupScroll() rAF loop —
                // its `attempt` checks this token every frame and stops
                // rescheduling itself once it no longer matches.
                this._groupScrollSettleToken++;
                this._stickyPanelResizeObserver?.disconnect();
                this._summaryVisibilityObserver?.disconnect();
                this._summaryVisibilityMql?.removeEventListener(
                    "change",
                    this._handleSummaryVisibilityMqlChange
                );
                clearTimeout(this._frequencyCollapseTimer);
                this._frequencyCollapseTimer = null;
                this._finishFrequencyCollapse = null;
                this._stickyOffsetMql?.removeEventListener(
                    "change",
                    this._handleStickyOffsetChange
                );
                window.removeEventListener("scroll", this.handleStickyCheck);
                window.removeEventListener("resize", this.handleStickyResize);
                this.disconnectQuickViewActionsVisibility();
                this._boxRequestController?.abort();
                this._quickViewRequestController?.abort();
                if (this._stickyFrame != null) {
                    cancelAnimationFrame(this._stickyFrame);
                    this._stickyFrame = null;
                }
                if (this._popupThumbsResizeHandler) {
                    window.removeEventListener(
                        "resize",
                        this._popupThumbsResizeHandler
                    );
                    this._popupThumbsResizeHandler = null;
                }
                if (this._frequencyBannerMql) {
                    this._frequencyBannerMql.removeEventListener(
                        "change",
                        this.handleFrequencyBannerBreakpointChange
                    );
                    this._frequencyBannerMql = null;
                }
            }

            hasSelectedWelcomeKitItems() {
                return Array.from(this.welcomeKitSelections.values()).some(
                    (selected) => selected.size > 0
                );
            }

            // "Applied" should only show once every required category has a
            // selection — not just as soon as any one of them does.
            isWelcomeKitApplied() {
                return (
                    this.hasSelectedWelcomeKitItems() &&
                    this.getUnmetRequiredWelcomeKitCategories().length === 0
                );
            }

            getSelectedWelcomeKitWorth() {
                if (this.hasSelectedWelcomeKitItems()) {
                    let worth = 0;
                    this.welcomeKitCategories.forEach((category) => {
                        const selected = this.welcomeKitSelections.get(
                            category.categoryName
                        );
                        if (!selected?.size) return;
                        (category.products || []).forEach((product) => {
                            if (!selected.has(product.variantId)) return;
                            worth +=
                                Number(product.compareAtPrice) ||
                                Number(product.price) ||
                                0;
                        });
                    });
                    return worth;
                }

                if (this.welcomeKitPlaceholderCompareAt > 0) {
                    return this.welcomeKitPlaceholderCompareAt;
                }

                return this.getWelcomeKitWorth();
            }

            async loadWelcomeKitPlaceholderCompareAt() {
                if (this.welcomeKitPlaceholderCompareAt > 0) return;
                const variantId = this.welcomeKitPlaceholderVariantId;
                if (!variantId) return;

                try {
                    const response = await fetch(`/variants/${variantId}.js`, {
                        credentials: "same-origin"
                    });
                    if (!response.ok) return;
                    const variant = await response.json();
                    const compareAtCents = Number(variant?.compare_at_price);
                    const priceCents = Number(variant?.price);
                    const cents =
                        Number.isFinite(compareAtCents) && compareAtCents > 0
                            ? compareAtCents
                            : Number.isFinite(priceCents) && priceCents > 0
                              ? priceCents
                              : 0;
                    if (cents > 0) {
                        this.welcomeKitPlaceholderCompareAt = cents / 100;
                    }
                } catch {
                    /* keep gift-sum fallback */
                }
            }

            getWelcomeKitWorth() {
                if (!this.welcomeKitCategories.length) return 0;

                const pickableValues = this.welcomeKitCategories.flatMap(
                    (category) => {
                        const maxSelections = category.maxSelections || 1;
                        const values = (category.products || [])
                            .map(
                                (product) =>
                                    Number(product.compareAtPrice) ||
                                    Number(product.price) ||
                                    0
                            )
                            .sort((a, b) => b - a);
                        return values.slice(0, maxSelections);
                    }
                );

                return pickableValues
                    .sort((a, b) => b - a)
                    .slice(0, WELCOME_KIT_MAX_ITEMS)
                    .reduce((sum, value) => sum + value, 0);
            }

            getPlanPricingState() {
                const basePrice = this.getBasePrice();
                const filledCount = this.getFilledCount();
                const tiers = this.getTiers();
                const maxTierSize = tiers.length
                    ? tiers[tiers.length - 1].size
                    : filledCount;
                const isSubscribed = this.purchaseType !== ONE_TIME;
                const isDesktop =
                    window.matchMedia("(min-width: 768px)").matches;
                const activePlanId = isSubscribed
                    ? this.purchaseType
                    : this.planEntries[0][0];
                const activePlan = this.box.sellingPlanGroup?.[activePlanId];
                const maxPercent = this.getPercentSaved(
                    maxTierSize,
                    basePrice,
                    activePlan
                );
                const subscribeTotal = roundMoney(
                    this.getUnitPriceForSize(
                        filledCount,
                        basePrice,
                        activePlan
                    ) * filledCount
                );
                const fullPrice = roundMoney(basePrice * filledCount);
                const oneTimeTotal = roundMoney(
                    this.getUnitPriceForSize(filledCount, basePrice, null) *
                        filledCount
                );
                const frequencyBannerText =
                    isSubscribed && isDesktop
                        ? this.frequencyBannerSubscribe
                              .replace("{percent}", maxPercent)
                              .replace(
                                  "{worth}",
                                  formatMoneyNoCodeRounded(
                                      this.hasSelectedWelcomeKitItems()
                                          ? this.getSelectedWelcomeKitWorth()
                                          : this.getWelcomeKitWorth(),
                                      this.box.currencyCode
                                  )
                              )
                        : this.frequencyBannerMobile;

                return {
                    activePlan,
                    activePlanId,
                    filledCount,
                    frequencyBannerText,
                    fullPrice,
                    isSubscribed,
                    maxPercent,
                    oneTimeTotal,
                    subscribeTotal
                };
            }

            renderFrequencyPrice(total, fullPrice, filledCount) {
                if (!filledCount) return "";
                const originalPrice =
                    fullPrice > total
                        ? `<s>${formatMoneyNoCode(fullPrice, this.box.currencyCode)}</s>`
                        : "";
                return `${originalPrice}${formatMoneyNoCode(
                    total,
                    this.box.currencyCode
                )}`;
            }

            updatePlanPricingUI() {
                const container = this.querySelector("[data-skio-plans]");
                if (!container || !this.planEntries?.length) return;

                const state = this.getPlanPricingState();
                const banner = container.querySelector(
                    "[data-skio-frequency-banner]"
                );
                const badge = container.querySelector(
                    "[data-skio-subscribe-badge]"
                );
                const subscribePrice = container.querySelector(
                    "[data-skio-subscribe-price]"
                );
                const oneTimePrice = container.querySelector(
                    "[data-skio-onetime-price]"
                );

                if (banner) banner.textContent = state.frequencyBannerText;
                if (badge)
                    badge.textContent = `Save up to ${state.maxPercent}%`;
                if (subscribePrice) {
                    subscribePrice.innerHTML = this.renderFrequencyPrice(
                        state.subscribeTotal,
                        state.fullPrice,
                        state.filledCount
                    );
                }
                if (oneTimePrice) {
                    oneTimePrice.innerHTML = this.renderFrequencyPrice(
                        state.oneTimeTotal,
                        state.fullPrice,
                        state.filledCount
                    );
                }
            }

            // Opening a group closes whichever other group was open (see the
            // groupToggle branch above). If that other group sits ABOVE the
            // one just opened, collapsing it removes ~its whole height from
            // the page during the ".skio-dynamic-box__group-body"
            // `grid-template-rows 0.3s` transition, which shifts the opened
            // header's position throughout the animation (there's no
            // `overflow-anchor` compensation — it's off on <html>). A scroll
            // computed at click time would target the pre-collapse layout.
            // So: wait for that transition to actually finish, then let
            // `scrollIntoView({block: "nearest"})` — combined with the
            // `scroll-margin-top` already on `.skio-dynamic-box__group-header`
            // — settle the header clear of the sticky panel. `transitionend`
            // is the primary trigger; the timer is only a fallback in case it
            // never fires (e.g. the transition gets interrupted).
            scheduleGroupScrollSettle(groupToggle) {
                this._pendingGroupScrollToggle = groupToggle;
                clearTimeout(this._groupScrollSettleTimer);
                this._groupScrollSettleTimer = setTimeout(
                    () => this.settleGroupScroll(),
                    450
                );
            }

            handleGroupTransitionEnd(event) {
                if (
                    event.propertyName !== "grid-template-rows" ||
                    !this._pendingGroupScrollToggle
                ) {
                    return;
                }
                clearTimeout(this._groupScrollSettleTimer);
                this._groupScrollSettleTimer = setTimeout(
                    () => this.settleGroupScroll(),
                    60
                );
            }

            // The transitionend trigger + 450ms fallback only tell us the
            // accordion *should* be done — not that it actually is. Firing
            // `settleGroupScroll` at either of those moments raced against
            // a genuinely still-running transition would compute the scroll
            // off a mid-animation layout and land wrong (the tab-hidden case
            // is the reliable repro: `grid-template-rows` isn't a composited
            // property, so it gets throttled hard in a background tab, but a
            // busy main thread — this page also runs Rebuy + Loox + reviews —
            // or a slow device can cause the exact same race). So instead of
            // trusting the trigger, confirm the geometry is actually settled
            // — no running Web Animations on the groups list, AND the
            // toggle's own rect.top unchanged across two consecutive frames —
            // before scrolling. `getAnimations` is Chrome 84+/Firefox 75+/
            // Safari 13.1+; where it's missing, this degrades to the rect.top
            // stability check alone rather than throwing.
            //
            // A hard ~2s deadline (from when this was scheduled) forces a
            // single scroll-and-stop instead of polling forever — needed for
            // prefers-reduced-motion (no transition, so "running" is never
            // true, but the deadline still lets it converge on the very next
            // rAF since rect.top is already stable) and for a transition
            // that gets interrupted mid-flight. As a side effect, a
            // backgrounded tab simply never reaches this until it's
            // foregrounded again (rAF doesn't tick while hidden) — by then
            // the layout is genuinely stable, so the eventual scroll is
            // correct. That's desired, not a bug.
            settleGroupScroll() {
                const toggle = this._pendingGroupScrollToggle;
                this._pendingGroupScrollToggle = null;
                if (!toggle || !toggle.isConnected) return;
                const groupEl = toggle.closest(".skio-dynamic-box__group");
                // Closed again (e.g. a second click landed before this
                // settled) or a different group won the accordion in the
                // meantime — don't scroll for a header that isn't the
                // current open one.
                if (!groupEl || !groupEl.classList.contains("is-open")) return;

                const token = ++this._groupScrollSettleToken;
                const wrap = this.querySelector(".skio-dynamic-box__groups");
                const deadline = performance.now() + 2000;
                let lastTop = null;

                const attempt = () => {
                    if (this._groupScrollSettleToken !== token) return;
                    if (
                        !toggle.isConnected ||
                        !groupEl.classList.contains("is-open")
                    ) {
                        return;
                    }

                    const expired = performance.now() > deadline;
                    const busy =
                        !expired &&
                        typeof wrap?.getAnimations === "function" &&
                        wrap
                            .getAnimations({ subtree: true })
                            .some((a) => a.playState === "running");
                    const top = Math.round(toggle.getBoundingClientRect().top);
                    const moved = top !== lastTop;
                    lastTop = top;

                    if (!expired && (busy || moved)) {
                        requestAnimationFrame(attempt);
                        return;
                    }

                    toggle.scrollIntoView({
                        block: "nearest",
                        behavior: "smooth"
                    });
                };

                requestAnimationFrame(attempt);
            }

            // Rolls up the currently visible Subscribe & Save / One-time
            // Purchase extra content (frequency select, welcome kit, perks)
            // before `done` swaps in the other purchase option's state —
            // reusing the same measured-height-to-0 collapse used by the
            // PDP's `.skio-dynamic-box__group-body` accordion, just driven
            // from JS instead of a CSS class toggle since the content here
            // is fully replaced (not just hidden) once the collapse ends.
            collapseFrequencyExtras(done, anchorEl, anchorSelector) {
                // A still-running collapse from a rapid earlier click must
                // finish (and apply its own render) before this one starts,
                // so renders can't stack out of order.
                this._finishFrequencyCollapse?.();

                const container = this.querySelector("[data-skio-plans]");
                const extras = container
                    ? Array.from(
                          container.querySelectorAll(
                              ".skio-dynamic-box__frequency-select-wrap, .skio-dynamic-box__welcome-kit, .skio-dynamic-box__frequency-perks"
                          )
                      )
                    : [];

                if (!extras.length) {
                    done();
                    return;
                }

                const DURATION = 300;
                let settled = false;
                let timer = null;
                let anchorRafId = null;

                // Content collapsing above `anchorEl` (the option the
                // customer just clicked) would otherwise carry it upward
                // with the page as it shrinks. Re-measure every frame of
                // the collapse and counter-scroll by whatever it drifted,
                // so the clicked option visually stays put — this is a
                // continuous compensation in lockstep with the animation,
                // not a one-off jump once it's already moved.
                let anchorTop = anchorEl
                    ? anchorEl.getBoundingClientRect().top
                    : null;
                const compensateAnchorDrift = () => {
                    if (anchorEl?.isConnected) {
                        const top = anchorEl.getBoundingClientRect().top;
                        const delta = top - anchorTop;
                        // `html`/`body` set `scroll-behavior: smooth`
                        // globally, which would otherwise queue every one
                        // of these per-frame corrections as its own
                        // animated scroll — they'd stack up and resolve in
                        // a delayed lurch instead of tracking the collapse
                        // frame-for-frame. Force instant so the correction
                        // lands immediately, every frame.
                        if (delta)
                            window.scrollBy({
                                top: delta,
                                left: 0,
                                behavior: "instant"
                            });
                        anchorTop = anchorEl.getBoundingClientRect().top;
                    }
                    if (!settled) {
                        anchorRafId = requestAnimationFrame(
                            compensateAnchorDrift
                        );
                    }
                };
                if (anchorEl) {
                    anchorRafId = requestAnimationFrame(
                        compensateAnchorDrift
                    );
                }

                const onTransitionEnd = (event) => {
                    if (
                        event.target !== extras[0] ||
                        event.propertyName !== "height"
                    )
                        return;
                    finish();
                };

                const finish = () => {
                    if (settled) return;
                    settled = true;
                    clearTimeout(timer);
                    this._frequencyCollapseTimer = null;
                    if (anchorRafId != null) cancelAnimationFrame(anchorRafId);
                    extras[0].removeEventListener(
                        "transitionend",
                        onTransitionEnd
                    );
                    this._finishFrequencyCollapse = null;

                    const lastAnchorTop = anchorTop;
                    done();

                    // `done()` re-renders the plans synchronously, which
                    // remounts the clicked option as a brand-new element —
                    // and, when switching to Subscribe & Save, can also
                    // reveal the welcome-kit teaser/picker for the first
                    // time (its content is only known once
                    // renderWelcomeKit() runs right after). Both happen
                    // outside the frame-by-frame compensation above, so
                    // land one last instant correction against whatever
                    // they shifted the option by. (The welcome-kit's own
                    // product carousel initializing Swiper a couple of
                    // frames later than this is handled separately, in CSS
                    // — see .skio-dynamic-box__welcome-kit-swiper — by
                    // reserving its post-init layout up front instead of
                    // chasing it with more scroll correction here.)
                    if (anchorSelector && lastAnchorTop != null) {
                        const newAnchor =
                            this.querySelector(anchorSelector);
                        if (newAnchor) {
                            const delta =
                                newAnchor.getBoundingClientRect().top -
                                lastAnchorTop;
                            if (delta) {
                                window.scrollBy({
                                    top: delta,
                                    left: 0,
                                    behavior: "instant"
                                });
                            }
                        }
                    }
                };

                this._finishFrequencyCollapse = finish;

                extras.forEach((el) => {
                    const cs = getComputedStyle(el);
                    el.style.height = `${el.offsetHeight}px`;
                    el.style.marginTop = cs.marginTop;
                    el.style.marginBottom = cs.marginBottom;
                    el.style.paddingTop = cs.paddingTop;
                    el.style.paddingBottom = cs.paddingBottom;
                    el.style.overflow = "hidden";
                });

                // Force layout so the explicit start height above is
                // registered before the end state is applied — otherwise
                // there's nothing for the transition to animate from.
                void extras[0].offsetHeight;

                requestAnimationFrame(() => {
                    extras.forEach((el) => {
                        el.style.transition =
                            "height 0.3s ease-in-out, opacity 0.3s ease-in-out, margin 0.3s ease-in-out, padding 0.3s ease-in-out";
                        el.style.height = "0px";
                        el.style.marginTop = "0px";
                        el.style.marginBottom = "0px";
                        el.style.paddingTop = "0px";
                        el.style.paddingBottom = "0px";
                        el.style.opacity = "0";
                    });
                });

                extras[0].addEventListener("transitionend", onTransitionEnd);
                // Fallback in case the transitionend never fires (e.g. the
                // element gets removed by an unrelated re-render mid-flight).
                timer = setTimeout(finish, DURATION + 80);
                this._frequencyCollapseTimer = timer;
            }

            renderPlans() {
                const container = this.querySelector("[data-skio-plans]");
                if (!container) return;

                if (!this.planEntries?.length) {
                    container.innerHTML = "";
                    return;
                }

                this.perksConfig = this.readPerksConfig();

                const {
                    activePlan,
                    activePlanId,
                    filledCount,
                    frequencyBannerText,
                    fullPrice,
                    isSubscribed,
                    maxPercent,
                    oneTimeTotal,
                    subscribeTotal
                } = this.getPlanPricingState();

                container.innerHTML = `
            <div class="skio-dynamic-box__frequency-group skio-dynamic-box__frequency-group--subscribe">
                <div class="skio-dynamic-box__frequency-banner" data-skio-frequency-banner>${frequencyBannerText}</div>
                <div class="skio-dynamic-box__frequency-option${isSubscribed ? " is-selected" : ""}">
                    <div class="skio-dynamic-box__frequency-option-top">
                        <label class="skio-dynamic-box__frequency-option-header">
                            <input type="radio" name="${this.purchaseInputName}" data-skio-purchase-type value="subscribe" ${isSubscribed ? "checked" : ""}>
                            <span class="skio-dynamic-box__frequency-label">Subscribe &amp; Save:</span>
                            <span class="badge badge-default badge-discount" data-skio-subscribe-badge>Save up to ${maxPercent}%</span>
                            <span class="skio-dynamic-box__frequency-price" data-skio-subscribe-price>
                                ${this.renderFrequencyPrice(subscribeTotal, fullPrice, filledCount)}
                            </span>
                        </label>
                        ${
                            isSubscribed && activePlan
                                ? `
                                    <div class="skio-dynamic-box__frequency-select-wrap">
                                        <select class="skio-dynamic-box__frequency-select" aria-label="Delivery frequency" data-skio-plan-select ${this.planEntries.length > 1 ? "" : "disabled"}>
                                            ${this.planEntries
                                                .map(
                                                    ([planId, plan]) => `
                                                        <option value="${planId}" ${planId === activePlanId ? "selected" : ""}>
                                                            Ships free every ${plan.intervalCount} ${plan.interval.toLowerCase()}s
                                                        </option>
                                                    `
                                                )
                                                .join("")}
                                        </select>
                                        <span class="skio-dynamic-box__frequency-select-chevron">${CHEVRON_DOWN_SVG}</span>
                                    </div>
                                `
                                : ""
                        }
                        ${!isSubscribed ? `<div class="skio-dynamic-box__welcome-kit" data-skio-welcome-kit hidden></div>` : ""}
                    </div>
                    ${this.buildPerksHtml(this.perksConfig?.subscribe)}
                    ${isSubscribed ? `<div class="skio-dynamic-box__welcome-kit" data-skio-welcome-kit hidden></div>` : ""}
                </div>
            </div>
            <div class="skio-dynamic-box__frequency-group skio-dynamic-box__frequency-group--onetime">
                <label class="skio-dynamic-box__frequency-option${!isSubscribed ? " is-selected" : ""}">
                    <div class="skio-dynamic-box__frequency-option-header">
                        <input type="radio" name="${this.purchaseInputName}" data-skio-purchase-type value="onetime" ${!isSubscribed ? "checked" : ""}>
                        <span class="skio-dynamic-box__frequency-label">One time purchase</span>
                        <span class="skio-dynamic-box__frequency-price" data-skio-onetime-price>
                            ${this.renderFrequencyPrice(oneTimeTotal, fullPrice, filledCount)}
                        </span>
                    </div>
                </label>
                ${!isSubscribed ? this.buildPerksHtml(this.perksConfig?.onetime) : ""}
            </div>
        `;
            }

            renderTiers() {
                const container = this.querySelector("[data-skio-tiers]");
                if (!container) return;

                const tiers = this.getTiers();
                if (!tiers.length) {
                    container.innerHTML = "";
                    return;
                }

                const basePrice = this.getBasePrice();
                const plan = this.getActivePlan();
                const filledCount = this.getFilledCount();

                container.innerHTML = `
            <div class="skio-dynamic-box__tier-row">
                ${tiers
                    .map((tier) => {
                        const percentSaved = this.getPercentSaved(
                            tier.size,
                            basePrice,
                            plan
                        );
                        const unitPrice = this.getUnitPriceForSize(
                            tier.size,
                            basePrice,
                            plan
                        );
                        const achieved = filledCount >= tier.size;
                        const unitLabel = filledCount
                            ? `${formatMoneyNoCode(unitPrice, this.box.currencyCode)} / per unit`
                            : "Add products for price";
                        const badgeLabel = percentSaved
                            ? achieved
                                ? `${percentSaved}% Saved`
                                : `Save ${percentSaved}%`
                            : !plan
                              ? achieved
                                  ? "OTP price"
                                  : `${tier.size} Pack`
                              : achieved
                                ? `${percentSaved}% Saved`
                                : `Save ${percentSaved}%`;
                        return `
                            <div class="skio-dynamic-box__tier${achieved ? " is-achieved" : ""}">
                                ${tier.isBestValue ? `<span class="skio-dynamic-box__tier-ribbon">Best value</span>` : ""}
                                <div class="skio-dynamic-box__tier-heading">
                                    <span>${tier.size} Pack</span>
                                    <span class="skio-dynamic-box__tier-badge">${badgeLabel}</span>
                                </div>
                                <span class="skio-dynamic-box__tier-dot">${achieved ? CHECKMARK_SVG : ""}</span>
                                <span class="skio-dynamic-box__tier-price">${unitLabel}</span>
                            </div>
                        `;
                    })
                    .join("")}
            </div>
        `;
            }

            renderSlots() {
                const slotsContainer = this.querySelector("[data-skio-slots]");
                const box = this.querySelector("[data-skio-box]");
                const countLabel = this.querySelector("[data-skio-count]");
                const chevron = this.querySelector("[data-skio-chevron]");
                if (!slotsContainer) return;

                const filledCount = this.getFilledCount();
                if (countLabel) {
                    countLabel.textContent = `${filledCount}/${this.slots.length} added`;
                }
                if (chevron) {
                    chevron.classList.toggle("is-open", this.summaryOpen);
                }
                if (box) {
                    slotsContainer.hidden = !this.summaryOpen;
                }

                slotsContainer.innerHTML = this.slots
                    .map((platformId, index) => {
                        if (!platformId) {
                            return `<div class="skio-dynamic-box__slot skio-dynamic-box__slot--empty"><span>+</span></div>`;
                        }
                        const variant =
                            this.variantsByPlatformId.get(platformId);
                        const productUrl = variant?.productHandle
                            ? `/products/${variant.productHandle}`
                            : "";
                        const slotMedia = `${
                            variant?.productImageSrc
                                ? `<img src="${variant.productImageSrc}" alt="${variant.productTitle || ""}" loading="lazy">`
                                : ""
                        }<p>${variant?.productTitle || ""}</p>`;
                        return `
                    <div class="skio-dynamic-box__slot" data-slot-index="${index}">
                        <button type="button" class="skio-dynamic-box__slot-remove" data-skio-remove aria-label="Remove item">&#10005;</button>
                        ${
                            productUrl
                                ? `<button type="button" class="skio-dynamic-box__slot-trigger" data-skio-quick-view data-product-url="${productUrl}" data-platform-id="${platformId}" aria-label="More details">${slotMedia}</button>`
                                : slotMedia
                        }
                    </div>
                `;
                    })
                    .join("");
            }

            renderGroupItemControls(platformId, count, maxReached) {
                const disableAdd = maxReached && count === 0;
                return count > 0
                    ? `
                <div class="skio-dynamic-box__stepper" data-skio-item-controls>
                    <button type="button" data-skio-decrement data-platform-id="${platformId}" aria-label="Decrease quantity">${MINUS_SVG}</button>
                    <span>${count}</span>
                    <button type="button" data-skio-increment data-platform-id="${platformId}" aria-label="Increase quantity" ${maxReached ? "disabled" : ""}>${PLUS_SVG}</button>
                </div>
            `
                    : `<button type="button" class="skio-dynamic-box__add-btn" data-skio-item-controls data-skio-increment data-platform-id="${platformId}" ${disableAdd ? "disabled" : ""}>Add</button>`;
            }

            renderGroups() {
                const container = this.querySelector("[data-skio-groups]");
                if (!container) return;

                const maxReached = this.getFilledCount() >= this.slots.length;

                container.innerHTML = this.groups
                    .map((group) => {
                        const isOpen = this.openGroups.has(group.title);
                        const selectedInGroup = group.products.reduce(
                            (sum, product) =>
                                sum +
                                (product.productVariants || []).reduce(
                                    (s, v) =>
                                        s +
                                        this.getCountForVariant(v.platformId),
                                    0
                                ),
                            0
                        );

                        return `
                    <div class="skio-dynamic-box__group${isOpen ? " is-open" : ""}" data-group-title="${group.title}">
                        <button type="button" class="skio-dynamic-box__group-header" data-skio-group-toggle>
                            <span class="skio-dynamic-box__group-header-text">
                            <span class="skio-dynamic-box__group-title-text" data-skio-group-title>${group.title}${selectedInGroup ? ` (${selectedInGroup})` : ""}</span>
                                ${
                                    group.supports?.length
                                        ? `<span class="skio-dynamic-box__group-badges">${group.supports
                                              .map(
                                                  (support) =>
                                                      `<span class="skio-dynamic-box__group-badge">${support}</span>`
                                              )
                                              .join("")}</span>`
                                        : ""
                                }
                            </span>
                            <span class="skio-dynamic-box__chevron${isOpen ? " is-open" : ""}">${CHEVRON_DOWN_SVG}</span>
                        </button>
                        ${
                            group.shortDescription
                                ? `<div class="skio-dynamic-box__group-description">${group.shortDescription}</div>`
                                : ""
                        }
                        <div class="skio-dynamic-box__group-body">
                            <div class="skio-dynamic-box__group-body-inner">
                            ${group.products
                                .map((product) => {
                                    const variant =
                                        this.getSingleUnitVariant(product);
                                    if (!variant) return "";
                                    const count = this.getCountForVariant(
                                        variant.platformId
                                    );
                                    const review =
                                        this.productReviewsByHandle?.get(
                                            product.productHandle
                                        );
                                    const badges =
                                        this.productBadgesByHandle?.get(
                                            product.productHandle
                                        );
                                    return `
                                        <div class="skio-dynamic-box__group-item${count ? " is-selected" : ""}" data-skio-group-item data-platform-id="${variant.platformId}">
                                            <span class="skio-dynamic-box__group-item-check" data-skio-group-item-check>${count ? CHECKMARK_SVG : ""}</span>
                                            ${product.productImageSrc ? `<img src="${product.productImageSrc}" alt="${product.productTitle || ""}" loading="lazy">` : ""}
                                            <div class="skio-dynamic-box__group-item-body">
                                                ${
                                                    badges?.length
                                                        ? `<span class="skio-dynamic-box__group-item-badges">${badges
                                                              .map(
                                                                  (badge) =>
                                                                      `<span class="skio-dynamic-box__group-item-badge">${badge}</span>`
                                                              )
                                                              .join("")}</span>`
                                                        : ""
                                                }
                                                ${
                                                    review?.id
                                                        ? `<product-reviews class="product-reviews">
                                                            <div class="loox-rating" data-id="${review.id}" data-rating="${review.rating || 0}" data-raters="${review.raters || 0}" data-pattern="([count])"></div>
                                                        </product-reviews>`
                                                        : ""
                                                }
                                                <p class="skio-dynamic-box__group-item-title">${product.productTitle || ""}</p>
                                                ${
                                                    product.productHandle
                                                        ? `<atlas-link-and-popup>
                                                            <div class="js-atlas-block-link" data-popup-id="${this.quickViewId}">
                                                                <button type="button" class="skio-dynamic-box__group-item-link" data-skio-quick-view data-product-url="/products/${product.productHandle}" data-platform-id="${variant.platformId}">More details</button>
                                                            </div>
                                                        </atlas-link-and-popup>`
                                                        : ""
                                                }
                                            </div>
                                            ${this.renderGroupItemControls(variant.platformId, count, maxReached)}
                                        </div>
                                    `;
                                })
                                .join("")}
                            </div>
                        </div>
                    </div>
                `;
                    })
                    .join("");

                this.initGroupListReviews();
            }

            initGroupListReviews() {
                const container = this.querySelector("[data-skio-groups]");
                if (!container) return;

                container.querySelectorAll(".loox-rating").forEach((looxEl) => {
                    if (looxEl.dataset.skioReviewsInit === "true") return;
                    looxEl.dataset.skioReviewsInit = "true";

                    const alreadyRendered = () =>
                        !!looxEl.querySelector(".loox-rating-content");

                    if (alreadyRendered()) {
                        this.enhanceLooxWidget(looxEl);
                        return;
                    }

                    if (window.LOOX?.init) {
                        try {
                            window.LOOX.init();
                        } catch (error) {
                            /* ignore */
                        }
                    }

                    const observer = new MutationObserver(() => {
                        if (alreadyRendered()) {
                            observer.disconnect();
                            clearTimeout(fallbackTimer);
                            this.enhanceLooxWidget(looxEl);
                        }
                    });
                    observer.observe(looxEl, {
                        childList: true,
                        subtree: true
                    });

                    const fallbackTimer = setTimeout(() => {
                        observer.disconnect();
                        if (!looxEl.isConnected) return;
                        if (alreadyRendered()) {
                            this.enhanceLooxWidget(looxEl);
                            return;
                        }
                        this.renderLooxFallback(looxEl);
                    }, 1200);
                });
            }

            updateGroupsSelectionUI() {
                const container = this.querySelector("[data-skio-groups]");
                if (!container) return;

                const maxReached = this.getFilledCount() >= this.slots.length;
                Array.from(container.children).forEach(
                    (groupEl, groupIndex) => {
                        const group = this.groups[groupIndex];
                        if (!group) return;

                        const selectedInGroup = group.products.reduce(
                            (sum, product) =>
                                sum +
                                (product.productVariants || []).reduce(
                                    (variantSum, variant) =>
                                        variantSum +
                                        this.getCountForVariant(
                                            variant.platformId
                                        ),
                                    0
                                ),
                            0
                        );
                        const titleEl = groupEl.querySelector(
                            "[data-skio-group-title]"
                        );
                        if (titleEl) {
                            titleEl.textContent = `${group.title}${
                                selectedInGroup ? ` (${selectedInGroup})` : ""
                            }`;
                        }

                        groupEl
                            .querySelectorAll("[data-skio-group-item]")
                            .forEach((itemEl) => {
                                const platformId = itemEl.dataset.platformId;
                                const count =
                                    this.getCountForVariant(platformId);
                                itemEl.classList.toggle(
                                    "is-selected",
                                    count > 0
                                );

                                const check = itemEl.querySelector(
                                    "[data-skio-group-item-check]"
                                );
                                if (check)
                                    check.innerHTML = count
                                        ? CHECKMARK_SVG
                                        : "";

                                const controls = itemEl.querySelector(
                                    "[data-skio-item-controls]"
                                );
                                if (controls) {
                                    controls.outerHTML =
                                        this.renderGroupItemControls(
                                            platformId,
                                            count,
                                            maxReached
                                        );
                                }
                            });
                    }
                );
            }

            renderWelcomeKitTeaser() {
                const image =
                    this.welcomeKitTeaserImage ||
                    this.welcomeKitCategories
                        .flatMap((category) => category.products || [])
                        .map((product) => product.image)
                        .find(Boolean);

                const worth = formatMoneyNoCodeRounded(
                    this.getWelcomeKitWorth(),
                    this.box.currencyCode
                );
                const heading = (
                    this.welcomeKitTeaserHeading ||
                    "+ Unlock a FREE Welcome Gift - {worth} Value"
                ).replace("{worth}", worth);
                const headingMobile = (
                    this.welcomeKitTeaserHeadingMobile ||
                    "+ FREE WELCOME KIT - {worth} VALUE"
                ).replace("{worth}", worth);
                const subheading =
                    this.welcomeKitTeaserSubheading ||
                    "Included in first subscription orders.";

                return `
            <div class="skio-dynamic-box__welcome-kit-teaser product-variants-group-gwp">
                ${
                    image
                        ? `<div class="gwp__img-wrapper">
                            <img src="${image}" alt="${heading}" width="47" height="49" loading="lazy" class="gwp__img">
                        </div>`
                        : ""
                }
                <div class="gwp__content">
                    <p class="gwp__title">
                        <span class="gwp__title-text-desktop">${heading}</span>
                        <span class="gwp__title-text-mobile">${headingMobile}</span>
                    </p>
                    <p class="gwp__subtitle">${subheading}</p>
                </div>
            </div>
        `;
            }

            renderWelcomeKit() {
                const container = this.querySelector("[data-skio-welcome-kit]");
                if (!container) return;

                if (!this.welcomeKitCategories.length) {
                    container.hidden = true;
                    container.innerHTML = "";
                    return;
                }

                if (!this.isSubscribing()) {
                    container.hidden = false;
                    container.innerHTML = this.renderWelcomeKitTeaser();
                    return;
                }

                container.hidden = false;
                const renderProductCard = (category, selected, product) => {
                    const isSelected = selected.has(product.variantId);
                    return `
                <button
                    type="button"
                    class="skio-dynamic-box__welcome-kit-product${isSelected ? " is-selected" : ""}"
                    data-skio-welcome-kit-pick
                    data-category="${category.categoryName}"
                    data-variant-id="${product.variantId}"
                >
                    <span class="skio-dynamic-box__welcome-kit-check">${isSelected ? CHECKMARK_SVG : ""}</span>
                    ${product.image ? `<img src="${product.image}" alt="${product.title || ""}" loading="lazy">` : ""}
                    <div class="skio-dynamic-box__welcome-kit-product-body">
                        <p class="skio-dynamic-box__welcome-kit-product-title">${product.title || ""}</p>
                        <p class="skio-dynamic-box__welcome-kit-product-price">
                            FREE
                            ${product.price ? `<span>${formatMoneyNoCode(product.price, this.box.currencyCode)}</span>` : ""}
                        </p>
                    </div>
                </button>
            `;
                };

                container.innerHTML = `
            <div class="skio-dynamic-box__welcome-kit-inner">
                <p class="skio-dynamic-box__welcome-kit-heading">${this.welcomeKitHeading}</p>
                ${this.welcomeKitSubheading ? `<p class="skio-dynamic-box__welcome-kit-subheading">${this.welcomeKitSubheading}</p>` : ""}
                ${this.welcomeKitCategories
                    .map((category) => {
                        const selected = this.welcomeKitSelections.get(
                            category.categoryName
                        );
                        const maxSelections = category.maxSelections || 1;
                        const useSlider = category.products.length > 3;

                        return `
                            <div class="skio-dynamic-box__welcome-kit-category" data-category-name="${category.categoryName}">
                                <div class="skio-dynamic-box__welcome-kit-category-header">
                                    <span class="skio-dynamic-box__welcome-kit-category-title">Select your ${category.categoryName}</span>
                                    <span class="skio-dynamic-box__welcome-kit-category-count" data-skio-welcome-kit-count>${selected.size}/${maxSelections}</span>
                                </div>
                                ${
                                    useSlider
                                        ? `
                                            <swiper-container
                                                init="false"
                                                class="skio-dynamic-box__welcome-kit-swiper"
                                                data-skio-welcome-kit-swiper
                                            >
                                                ${category.products
                                                    .map(
                                                        (product) => `
                                                            <swiper-slide>
                                                                ${renderProductCard(category, selected, product)}
                                                            </swiper-slide>
                                                        `
                                                    )
                                                    .join("")}
                                            </swiper-container>
                                        `
                                        : `
                                            <div class="skio-dynamic-box__welcome-kit-products">
                                                ${category.products
                                                    .map((product) =>
                                                        renderProductCard(
                                                            category,
                                                            selected,
                                                            product
                                                        )
                                                    )
                                                    .join("")}
                                            </div>
                                        `
                                }
                            </div>
                        `;
                    })
                    .join("")}
            </div>
        `;

                container
                    .querySelectorAll("[data-skio-welcome-kit-swiper]")
                    .forEach((swiperEl) => this.initWelcomeKitSwiper(swiperEl));
            }

            initWelcomeKitSwiper(swiperEl) {
                if (swiperEl.swiper) return;

                Object.assign(swiperEl, {
                    // "auto" keeps each slide at the width set in CSS
                    // (--welcome-kit-product-width) instead of Swiper resizing them.
                    slidesPerView: "auto",
                    spaceBetween: 10,
                    watchOverflow: true,
                    observer: true,
                    resizeObserver: true,
                    pagination: { enabled: true, clickable: true },
                    navigation: { enabled: false },
                    breakpoints: {
                        990: {
                            slidesPerView: "auto",
                            spaceBetween: 10,
                            navigation: { enabled: true }
                        }
                    }
                });

                if (!swiperEl.hasAttribute("init")) {
                    swiperEl.setAttribute("init", "false");
                }

                const updateEdgeClasses = () => {
                    const swiper = swiperEl.swiper;
                    if (!swiper) return;
                    swiperEl.classList.toggle(
                        "is-at-start",
                        swiper.isBeginning
                    );
                    swiperEl.classList.toggle("is-at-end", swiper.isEnd);
                };

                swiperEl.addEventListener(
                    "swiperslidechange",
                    updateEdgeClasses
                );
                swiperEl.addEventListener(
                    "swiperreachbeginning",
                    updateEdgeClasses
                );
                swiperEl.addEventListener("swiperreachend", updateEdgeClasses);
                swiperEl.addEventListener("swiperfromedge", updateEdgeClasses);

                // The element was just inserted via innerHTML — wait a frame so the
                // browser has actually laid it out before Swiper measures its width.
                // Initializing too early makes Swiper divide by a zero/unset width,
                // producing absurd slide widths (e.g. width: 1.04857e+07px).
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        if (!swiperEl.isConnected || swiperEl.swiper) return;
                        if (typeof swiperEl.initialize !== "function") return;
                        try {
                            swiperEl.initialize();
                            if (swiperEl.swiper?.update) {
                                swiperEl.swiper.update();
                            }
                            updateEdgeClasses();
                            swiperEl.classList.add("is-initialized");
                        } catch (error) {
                            console.warn(
                                "AtlasSkioDynamicBox: welcome kit swiper failed to initialize",
                                error
                            );
                        }
                    });
                });
            }

            getGroupTitleForHandle(handle) {
                return (
                    this.handleToGroupTitle?.get(handle) || OTHER_GROUP_TITLE
                );
            }

            renderSummary() {
                const summary = this.querySelector("[data-skio-summary]");
                if (!summary || !this.box) return;

                const filledCount = this.getFilledCount();
                if (!filledCount) {
                    summary.hidden = false;
                    summary.innerHTML = `
                <button type="button" class="skio-dynamic-box__bundle-header" data-skio-bundle-toggle>
                    <span>Bundle Summary:</span>
                    <span class="skio-dynamic-box__chevron${this.bundleSummaryOpen === false ? "" : " is-open"}">${CHEVRON_DOWN_SVG}</span>
                </button>
                <div class="skio-dynamic-box__bundle-body" ${this.bundleSummaryOpen === false ? "hidden" : ""}>
                    <div class="skio-dynamic-box__summary-row skio-dynamic-box__summary-row--empty">
                        <span>Add products to see your bundle price</span>
                        <span class="skio-dynamic-box__summary-row-price">${formatMoneyNoCode(0, this.box.currencyCode)}</span>
                    </div>
                </div>
            `;
                    this.renderSubmitButton(0, 0);
                    return;
                }
                summary.hidden = false;

                const basePrice = this.getBasePrice();
                const plan = this.getActivePlan();
                const isSubscribed = this.isSubscribing();
                const subtotal = roundMoney(basePrice * filledCount);

                const countsByVariant = new Map();
                this.slots.filter(Boolean).forEach((platformId) => {
                    countsByVariant.set(
                        platformId,
                        (countsByVariant.get(platformId) || 0) + 1
                    );
                });

                const lineRows = Array.from(countsByVariant.entries())
                    .map(([platformId, qty]) => {
                        const variant =
                            this.variantsByPlatformId.get(platformId);
                        if (!variant) return null;
                        const groupTitle = this.getGroupTitleForHandle(
                            variant.productHandle
                        );
                        const unitOriginal = Number(variant.price) || 0;
                        const itemOriginal = roundMoney(unitOriginal * qty);
                        const unitDiscounted = this.getUnitPriceForSize(
                            filledCount,
                            unitOriginal,
                            plan
                        );
                        const itemDiscounted = roundMoney(unitDiscounted * qty);
                        return {
                            platformId,
                            qty,
                            variant,
                            groupTitle,
                            itemOriginal,
                            itemDiscounted
                        };
                    })
                    .filter(Boolean);

                const total = roundMoney(
                    lineRows.reduce((sum, row) => sum + row.itemDiscounted, 0)
                );
                const welcomeKitWorth =
                    isSubscribed && this.isWelcomeKitApplied()
                        ? roundMoney(this.getSelectedWelcomeKitWorth())
                        : 0;
                const discount = Math.max(
                    0,
                    roundMoney(subtotal - total + welcomeKitWorth)
                );

                const shippingCost = isSubscribed
                    ? 0
                    : this.oneTimeShippingCost;

                const bundleTotal = roundMoney(total + (shippingCost || 0));
                const bundleOriginal = roundMoney(
                    subtotal + (shippingCost || 0)
                );

                summary.innerHTML = `
            <button type="button" class="skio-dynamic-box__bundle-header" data-skio-bundle-toggle>
                <span>Bundle Summary:</span>
                <span class="skio-dynamic-box__chevron${this.bundleSummaryOpen === false ? "" : " is-open"}">${CHEVRON_DOWN_SVG}</span>
            </button>
            <div class="skio-dynamic-box__bundle-body" ${this.bundleSummaryOpen === false ? "hidden" : ""}>
                ${lineRows
                    .map((row) => {
                        const fullTitle = `${row.variant.productTitle}${row.groupTitle ? ` - ${row.groupTitle}` : ""}`;
                        return `
                            <div class="skio-dynamic-box__summary-row">
                                <span>
                                    <span class="skio-dynamic-box__summary-row-title" title="${fullTitle.replace(/&/g, "&amp;").replace(/"/g, "&quot;")}">${row.qty > 1 ? `<span class="skio-dynamic-box__summary-row-qty">${row.qty}&times;</span> ` : ""}${fullTitle}</span>
                                </span>
                                <span class="skio-dynamic-box__summary-row-price">
                                    ${formatMoneyNoCode(row.itemDiscounted, this.box.currencyCode)}
                                    ${row.itemDiscounted < row.itemOriginal ? `<s>${formatMoneyNoCode(row.itemOriginal, this.box.currencyCode)}</s>` : ""}
                                </span>
                            </div>
                        `;
                    })
                    .join("")}
                ${
                    isSubscribed && this.isWelcomeKitApplied()
                        ? `<div class="skio-dynamic-box__summary-row skio-dynamic-box__summary-row--welcome-kit">
                            <span>
                                Welcome Kit
                                <span class="skio-dynamic-box__badge-muted skio-dynamic-box__badge-muted--positive">Applied ${CHECKMARK_SVG}</span>
                            </span>
                            <span class="skio-dynamic-box__summary-row-price">
                                FREE
                                <s>${formatMoneyNoCode(this.getSelectedWelcomeKitWorth(), this.box.currencyCode)}</s>
                            </span>
                        </div>`
                        : !isSubscribed && this.welcomeKitCategories.length
                          ? `<div class="skio-dynamic-box__summary-row skio-dynamic-box__summary-row--welcome-kit">
                                <span>Welcome Kit</span>
                                <span class="skio-dynamic-box__badge-muted skio-dynamic-box__badge-muted--negative">Subscriptions only ${CLOSE_X_SVG}</span>
                            </div>`
                          : ""
                }
                ${
                    isSubscribed
                        ? ""
                        : `<div class="skio-dynamic-box__summary-row">
                                <span>Shipping</span>
                                <span class="skio-dynamic-box__summary-row-price">${
                                    this.oneTimeShippingCost
                                        ? formatMoneyNoCode(
                                              this.oneTimeShippingCost,
                                              this.box.currencyCode
                                          )
                                        : "Calculated at checkout"
                                }</span>
                            </div>`
                }
                <div class="skio-dynamic-box__summary-row skio-dynamic-box__summary-row--total skio-dynamic-box__summary-row--savings">
                    <span>Total Savings</span>
                    <span class="skio-dynamic-box__summary-row-price">${formatMoneyNoCode(discount, this.box.currencyCode)}${isSubscribed ? " + Free shipping" : ""}</span>
                </div>
                <div class="skio-dynamic-box__summary-row skio-dynamic-box__summary-row--total">
                    <span>Bundle Total</span>
                    <span class="skio-dynamic-box__summary-row-price">
                        ${formatMoneyNoCode(bundleTotal, this.box.currencyCode)}
                        ${bundleTotal < bundleOriginal ? `<s>${formatMoneyNoCode(bundleOriginal, this.box.currencyCode)}</s>` : ""}
                    </span>
                </div>
            </div>
        `;

                this.renderSubmitButton(bundleTotal, bundleOriginal);
            }

            renderSubmitButton(bundleTotal, bundleOriginal) {
                const submitButton = this.querySelector("[data-skio-submit]");
                if (!submitButton || this.isSubmitting) return;

                submitButton.disabled =
                    this.getFilledCount() < this.getMinimumBoxSize();

                submitButton.innerHTML = bundleTotal
                    ? `
                ${this.buttonLabel} - ${formatMoneyNoCode(bundleTotal, this.box.currencyCode)}
                ${bundleTotal < bundleOriginal ? `<s>${formatMoneyNoCode(bundleOriginal, this.box.currencyCode)}</s>` : ""}
            `
                    : this.buttonLabel;
            }

            renderLoading() {
                this.innerHTML = `<div class="skio-dynamic-box skio-dynamic-box--loading">Loading box…</div>`;
            }

            renderError(message) {
                const existing = this.querySelector("[data-skio-error]");
                if (existing) {
                    existing.hidden = false;
                    existing.textContent = message;
                    return;
                }
                this.innerHTML = `<p class="skio-dynamic-box__error" data-skio-error>${message}</p>`;
            }

            resolveSellingPlanId(plan, variantPlatformId) {
                if (!plan || this.purchaseType === ONE_TIME) return null;
                // The plan (subscription frequency) applies to the whole box, so
                // every variant added under it shares the same selling_plan id —
                // the sellingPlanGroup key itself, per Skio's Dynamic Box API.
                // When allMatch is true every variant supports this plan and
                // variantMapping is left empty; only check it when allMatch is false.
                if (!plan.allMatch) {
                    const mapping = plan.variantMapping || {};
                    if (!(variantPlatformId in mapping)) return null;
                }
                return extractNumericId(this.purchaseType);
            }

            async resolveDynamicBoxIndex(boxId) {
                if (!boxId) return 0;

                try {
                    const cart = await fetch("/cart.js", {
                        credentials: "same-origin"
                    }).then((response) => response.json());

                    let maxIndex = -1;
                    for (const line of cart.items || []) {
                        const properties = line.properties || {};
                        if (
                            String(properties._dynamicBoxId) !== String(boxId)
                        ) {
                            continue;
                        }
                        const index = parseInt(properties._dynamicBoxIndex, 10);
                        if (!Number.isNaN(index)) {
                            maxIndex = Math.max(maxIndex, index);
                        }
                    }
                    return maxIndex + 1;
                } catch {
                    return 0;
                }
            }

            async handleSubmit() {
                if (this.isSubmitting) return;

                const filled = this.slots.filter(Boolean);
                if (!filled.length) {
                    this.renderError(
                        "Please add at least one item to your box."
                    );
                    return;
                }

                const minimumBoxSize = this.getMinimumBoxSize();
                if (filled.length < minimumBoxSize) {
                    this.renderError(
                        `Please add at least ${minimumBoxSize} items to your box.`
                    );
                    return;
                }

                const unmetRequired =
                    this.getUnmetRequiredWelcomeKitCategories();
                if (unmetRequired.length) {
                    const categoryNames = unmetRequired
                        .map((category) => category.categoryName)
                        .join(", ");
                    this.renderError(
                        `Please select your ${categoryNames} before adding to cart.`
                    );
                    return;
                }

                const plan = this.getActivePlan();
                const dynamicBoxId = this.box?.boxId;
                if (!dynamicBoxId) {
                    this.renderError(
                        "Something went wrong with this box. Please try again."
                    );
                    return;
                }

                const isSubscribed = this.isSubscribing();
                const dynamicBoxIndex = isSubscribed
                    ? await this.resolveDynamicBoxIndex(dynamicBoxId)
                    : 0;
                const otpByobBoxId = isSubscribed
                    ? null
                    : `otp-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

                const items = filled.map((variantPlatformId) => {
                    const variantId = extractNumericId(variantPlatformId);
                    const properties = {
                        _byob: "true"
                    };
                    if (isSubscribed) {
                        properties._dynamicBoxId = dynamicBoxId;
                        properties._dynamicBoxIndex = dynamicBoxIndex;
                    } else if (otpByobBoxId) {
                        properties._otpByobBoxId = otpByobBoxId;
                    }
                    const item = {
                        id: variantId,
                        quantity: 1,
                        properties
                    };

                    if (plan) {
                        const sellingPlanId = this.resolveSellingPlanId(
                            plan,
                            variantPlatformId
                        );
                        if (sellingPlanId) {
                            item.selling_plan = sellingPlanId;
                        }
                    }

                    return item;
                });

                if (items.some((item) => !item.id)) {
                    this.renderError(
                        "Something went wrong with this box. Please try again."
                    );
                    return;
                }

                const welcomeKitSelectionSummary = [];

                const hasWelcomeKitSelection = Array.from(
                    this.welcomeKitSelections.values()
                ).some((selected) => selected && selected.size > 0);

                if (this.isSubscribing() && hasWelcomeKitSelection) {
                    if (!this.welcomeKitPlaceholderVariantId) {
                        this.renderError(
                            "Welcome kit placeholder is not configured. Set the placeholder variant ID in the Dynamic Box block settings."
                        );
                        return;
                    }

                    const kitProperties = {
                        _welcome_kit: "true",
                        _byob: "true"
                    };

                    this.welcomeKitCategories.forEach((category) => {
                        const selectedVariantIds =
                            this.welcomeKitSelections.get(
                                category.categoryName
                            ) || new Set();
                        if (!selectedVariantIds.size) return;

                        const propKey = String(
                            category.categoryHandle ||
                                category.categoryName ||
                                ""
                        )
                            .trim()
                            .toLowerCase();
                        if (!propKey) return;

                        const selectedItems = Array.from(selectedVariantIds)
                            .map((variantId) => {
                                const productInfo = category.products?.find(
                                    (p) =>
                                        String(p.variantId) ===
                                        String(variantId)
                                );
                                const numericVariantId =
                                    extractNumericId(variantId);
                                const numericProductId = extractNumericId(
                                    productInfo?.productId
                                );
                                const title = String(
                                    productInfo?.title || ""
                                ).trim();
                                const id = numericVariantId || numericProductId;

                                if (numericVariantId) {
                                    welcomeKitSelectionSummary.push({
                                        category: category.categoryName,
                                        categoryHandle: propKey,
                                        variantId: numericVariantId,
                                        productId: numericProductId,
                                        title: title || null,
                                        handle: productInfo?.handle || null
                                    });
                                }

                                if (!id) return null;
                                return {
                                    id,
                                    productId: numericProductId,
                                    variantId: numericVariantId,
                                    title
                                };
                            })
                            .filter(Boolean);

                        if (!selectedItems.length) return;

                        kitProperties[`_${propKey}`] = selectedItems
                            .map(
                                (item) =>
                                    item.productId || item.variantId || item.id
                            )
                            .filter(Boolean)
                            .join(",");
                        kitProperties[`_${propKey}_variant`] = selectedItems
                            .map((item) => item.variantId)
                            .filter(Boolean)
                            .join(",");

                        const displayLabel = String(
                            category.categoryName || propKey
                        ).trim();
                        const displayNames = selectedItems
                            .map((item) => item.title)
                            .filter(Boolean);
                        if (displayLabel && displayNames.length) {
                            kitProperties[displayLabel] =
                                displayNames.join(", ");
                        }
                    });

                    items.push({
                        id: this.welcomeKitPlaceholderVariantId,
                        quantity: 1,
                        properties: kitProperties
                    });
                }

                this.isSubmitting = true;
                const submitButton = this.querySelector("[data-skio-submit]");
                if (submitButton) {
                    submitButton.disabled = true;
                    submitButton.textContent = "Adding…";
                }

                try {
                    const response = await fetch("/cart/add.js", {
                        method: "POST",
                        credentials: "same-origin",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ items })
                    });

                    const result = await response.json();
                    if (!response.ok) {
                        console.error(
                            "[SkioDynamicBox] cart/add.js error response:",
                            result
                        );
                        throw new Error(
                            result?.description || "Add to cart failed"
                        );
                    }

                    const setByobCartAttributes = async () => {
                        const latestCart = await fetch("/cart.js", {
                            credentials: "same-origin"
                        })
                            .then((r) => r.json())
                            .catch(() => null);

                        const attributesPayload = {
                            attributes: {
                                ...(latestCart?.attributes || {}),
                                byob: "true",
                                welcome_kit_selection: JSON.stringify(
                                    welcomeKitSelectionSummary
                                )
                            }
                        };

                        const attributesResponse = await fetch(
                            "/cart/update.js",
                            {
                                method: "POST",
                                credentials: "same-origin",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify(attributesPayload)
                            }
                        );
                        return attributesResponse.json().catch(() => null);
                    };

                    await setByobCartAttributes();

                    invalidateCartCache();
                    await refreshRebuyCart();
                    await setByobCartAttributes();
                    this.updateCartHeaderBubble();
                    document.dispatchEvent(
                        new CustomEvent("cart:updated", { bubbles: true })
                    );
                } catch (error) {
                    console.error(
                        "AtlasSkioDynamicBox: add to cart failed",
                        error
                    );
                    this.renderError(
                        "We couldn't add this box to your cart. Please try again."
                    );
                } finally {
                    this.isSubmitting = false;
                    if (submitButton) {
                        submitButton.disabled = false;
                    }
                    this.renderSummary();
                }
            }

            updateCartHeaderBubble() {
                if (
                    typeof window.atlasGwpShared?.syncCartCountBubble ===
                    "function"
                ) {
                    window.atlasGwpShared.syncCartCountBubble();
                    return;
                }

                fetch("/cart.js", { credentials: "same-origin" })
                    .then((response) => response.json())
                    .then((cart) => {
                        const itemCount = Number(cart?.item_count) || 0;
                        if (
                            typeof window.atlasGwpShared
                                ?.updateCartCountBubble === "function"
                        ) {
                            window.atlasGwpShared.updateCartCountBubble(
                                itemCount
                            );
                            return;
                        }

                        const cartIcon =
                            document.getElementById("cart-icon-bubble");
                        if (!cartIcon) return;

                        let bubble =
                            cartIcon.querySelector(".cart-count-bubble");
                        if (!bubble) {
                            bubble = document.createElement("div");
                            bubble.className = "cart-count-bubble";
                            cartIcon.appendChild(bubble);
                        }

                        if (itemCount <= 0) {
                            bubble.setAttribute("hidden", "");
                            return;
                        }

                        bubble.removeAttribute("hidden");
                        let countSpan = bubble.querySelector(
                            "span[aria-hidden='true']"
                        );
                        if (!countSpan) {
                            countSpan = document.createElement("span");
                            countSpan.setAttribute("aria-hidden", "true");
                            bubble.insertBefore(countSpan, bubble.firstChild);
                        }
                        countSpan.textContent = String(itemCount);
                    })
                    .catch(() => {});
            }
        }

        customElements.define("atlas-skio-dynamic-box", AtlasSkioDynamicBox);
    })();
}
